<style>
.checklist_tb th.td-check .con-vs-checkbox {
  margin-right: 0 !important;
  display: none !important;
  margin-left: 0 !important;
}
.checklist_tb th.td-check .con-vs-checkbox {
  margin-right: 0 !important;
  display: none !important;
  margin-left: 0 !important;
}
.signature_pad {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.wrapper {
  max-width: 300px;
  margin: 0 auto;
}
#templateWrap img {
  border-radius: 30px;
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

#templateWrap .des {
  float: right;
  padding-left: 10px;
  line-height: 30px;
}
[dir] .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #fafafa;
  opacity: 0.5;
}
</style>

<template>
  <vx-card>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <div class="vx-row">
          <div class="vx-col w-full mb-4">
          </div>
        </div>
        <hr />
        <div class="vx-row mt-2">
          <div class="vx-col md:w-1/5 sm:w-full w-full">
            <label for>Fecha inicial</label>
            <datepicker
              v-model="fcalendarEdit"
              color="grey darken-4"
              :language="languages.es"
              format="yyyy-MM-dd"
            ></datepicker>
            <!-- <v-date-picker v-model="fcalendarEdit" @input="mfechaEdit = false" color="grey darken-4" locale="es"></v-date-picker> -->
          </div>
          <div class="vx-col md:w-1/5 sm:w-full w-full">
            <label for>Fecha final</label>
            <datepicker
              v-model="fcalendarFinal"
              color="grey darken-4"
              :language="languages.es"
              format="yyyy-MM-dd"
            ></datepicker>
          </div>
          <div class="vx-col md:w-1/5 sm:w-full w-full">
            <label for>Búsqueda Vehículo/Mantenible:</label>
            <vs-input
                v-model="vBusquedaVehiculo"
                class="w-full"
                maxlength="250"
                placeholder=""
              />
            <!-- <v-date-picker v-model="fcalendarEdit" @input="mfechaEdit = false" color="grey darken-4" locale="es"></v-date-picker> -->
          </div>
          <div class="vx-col md:w-1/5 sm:w-full w-full">
            <label for>Búsqueda detalle:</label>
            <vs-input
                v-model="vBusquedaAveria"
                class="w-full"
                maxlength="250"
                placeholder=""
              />
            <!-- <v-date-picker v-model="fcalendarEdit" @input="mfechaEdit = false" color="grey darken-4" locale="es"></v-date-picker> -->
          </div>
          <div class="vx-col md:w-1/5 sm:w-full w-full">
            <label for>Tipo</label>
            <v-select
              v-model="FiltroAveria"
              :options="tipoAverias"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col md:w-1/4 sm:w-full w-full">
            <label for>Incidencia</label>
            <v-select
              v-model="vIncidencia"
              :options="IncidenciasAsociadas"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="danger"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-refresh-ccw"
              v-on:click="cancelSearchInspeccion()"
            >Cancelar</vs-button>
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="primary"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="searchInspeccion()"
            >Buscar</vs-button>
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="dark"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
              :v-if="ActiveHI"
              @click="ActivePopup()"
            >Agregar</vs-button>
          </div>          
        </div>
      </div>
    </div>
    <hr />
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <ag-grid-vue
          ref="agGridTable"
          v-if="renderComponents"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="datos.columnDefs"
          :defaultColDef="datos.defaultColDef"
          :rowData="datos.json"
          autoSizeColumns="true"
          :animateRows="false"
          :floatingFilter="false"
          :pagination="true"
          :paginationPageSize="15"
          :suppressDragLeaveHidesColumns="false"
          :suppressMovable="false"
          :suppressPaginationPanel="false"
          overlayNoRowsTemplate="No se encontraron resultados."
          :enableRtl="$vs.rtl"
          style="max-height: 400px;width:100%"
          id
        ></ag-grid-vue>
      </div>
    </div>

    <vs-popup fullscreen :title="titlePopup" :active.sync="popupActive">
      <form-wizard
        ref="wizard"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        :finishButtonText="fgConsultar ? 'Cerrar' :'Guardar'"
        nextButtonText="Siguiente"
        backButtonText="Regresar"
        @on-complete="formSubmitted"
        @on-change="handleValidation"
      >
        <tab-content title="Datos generales" class="mb-5" :before-change="validateStep1">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgCliente.fgVisible">
                <label for>Cliente</label>
                <v-select
                  v-model="idCliente"
                  :options="options1"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}" id="template1">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                  </template>
                </v-select>

                <!-- :required="!idCliente"
                name="v_idCliente"
                      v-validate="!idCliente ? 'required' : ''"
                <span class="text-danger validate-message">{{ errors.first('step-1.v_idCliente') }}</span>-->
                <br />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgNombreCliente.fgVisible">
                <label for>Nombre</label>
                <vs-input
                  v-model="Nombre"
                  class="w-full"
                  maxlength="250"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                />

                <!-- name="v_Nombre"
                  v-validate="fgNombreCliente.fgVisible ? 'required' : ''"
                <span class="text-danger validate-message">{{ errors.first('step-1.v_Nombre') }}</span>-->
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoDocumento.fgVisible">
                <label for>Tipo de documento</label>
                <v-select
                  v-model="idTipoDocumento"
                  :options="options2"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoDocumento"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoDocumento"
                      v-validate="!idTipoDocumento ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoDocumento') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoVehiculo.fgVisible">
                <label for>Tipo de Vehículo/Mantenible</label>
                <v-select
                  v-model="idTipoVehiculo"
                  :options="TiposVehiculos"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoVehiculo"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoVehiculo"
                      v-validate="!idTipoVehiculo ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoVehiculo') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgVehiculo.fgVisible">
                <label for>Vehículo/Mantenible</label>
                <v-select
                  v-model="idVehiculo"
                  :options="options4"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idVehiculo"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idVehiculo"
                      v-validate="!idVehiculo ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idVehiculo') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgOperador.fgVisible">
                <label for>Operador/conductor</label>
                <v-select
                  v-model="idOperador"
                  :options="optionsO"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}" id="template1">
                    <input class="vs__search" v-bind="attributes" v-on="events" name="v_idOperador" />
                  </template>
                </v-select>
                <br />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgAyudante.fgVisible">
                <label for>Ayudante </label>
                <v-select
                  v-model="idAyudante"
                  :options="options6"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                  multiple
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}" id="template1">
                    <input class="vs__search" v-bind="attributes" v-on="events" name="v_idAyudante" />
                  </template>
                </v-select>
                <br />
              </div>
              <!-- <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoChasis.fgVisible">
                <label for>Tipo de chasis</label>
                <v-select v-model="idTipoChasis" :options="options3" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoChasis"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoChasis"
                      v-validate="!idTipoChasis ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoChasis') }}</span>
              </div>-->
              <!-- </div> -->
              <!-- <div class="vx-row"> -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgContrato.fgVisible">
                <label for>Contrato</label>
                <vs-input
                  v-model="Contrato"
                  class="w-full"
                  name="v_Contrato"
                  v-validate="fgContrato.fgVisible ? 'required' : ''"
                  maxlength="250"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                />
                <span class="text-danger">{{ errors.first('step-1.v_Contrato') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgFactura.fgVisible">
                <label for>Factura</label>
                <vs-input
                  v-model="Factura"
                  class="w-full"
                  name="v_Factura"
                  maxlength="250"
                  v-validate="fgFactura.fgVisible ? 'required' : ''"
                  :disabled="fgConsultar ? true : false"
                />
                <span class="text-danger">{{ errors.first('step-1.v_Factura') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgEstacion.fgVisible">
                <label for>Estación dueña</label>
                <v-select
                  v-model="idEstacion"
                  :options="options5"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idEstacion"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idEstacion"
                      v-validate="!idEstacion && fgEstacion.fgVisible ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idEstacion') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgInspector.fgVisible">
                <label for>Inspector de operaciones</label>
                <v-select
                  v-model="idEmpleado"
                  :options="options6"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idEmpleado"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idEmpleado"
                      v-validate="!idEmpleado? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idEmpleado') }}</span>
              </div>
            </div>
            <hr class="my-3" />
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Marca y Modelo</label>
                <vs-input v-model="MarcaModelo" disabled class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Descripción</label>
                <vs-input v-model="Descripcion" disabled class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Placas</label>
                <vs-input v-model="Placa" disabled class="w-full" />
              </div>
            </div>
            <div class="vx-row" v-if="fgVisibleLlanta">
              <hr class="my-5" />
              <h5 v-if="fgVisibleLlanta" class="mt-5">Llantas</h5>
            </div>
            <div class="vx-row" v-if="fgVisibleLlanta">
              <div
                class="vx-col lg:1/4 md:w-1/3 sm:w-full w-full mt-5"
                :key="index"
                v-for="(item, index) in LsLlantas"
              >
                <vx-card>
                  <b>NS:</b>
                  {{item.SN}}
                  <br />
                  <b>ECO:</b>
                  {{item.NumeroEconomico}}
                  <br />
                  <b>MARCA:</b>
                  {{item.Marca}}
                  <br />
                  <b>MOD:</b>
                  {{item.Modelo}}
                </vx-card>
              </div>
            </div>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content
          title="Estatus inicial del Vehículo/Mantenible"
          class="mb-5"
          :before-change="validateStep2"
        >
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-show="fgTipoCombustible.fgVisible"
              >
                <label for>Tipo de combustible</label>
                <v-select
                  v-model="idTipoCombustible"
                  :options="options8"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="true"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoCombustible"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoCombustible"
                      v-validate="!idTipoCombustible && fgTipoCombustible.fgVisible ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-2.v_idTipoCombustible') }}</span>
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-show="fgKilometrajeSalida.fgVisible"
              >
                <label for>Kilometraje de salida</label>
                <vs-input
                  v-model="Kilometraje"
                  :required="!Kilometraje"
                  v-validate="!Kilometraje && fgKilometrajeSalida.fgVisible ? 'required' : ''"
                  class="w-full"
                  :disabled="fgConsultar ? true : HojaIID > 0 && fgLlegada ? true : false"
                  name="v_Kilometraje"
                />
                <span class="text-danger">{{ errors.first('step-2.v_Kilometraje') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5" v-show="fgFechaSalida.fgVisible">
                <label for>Fecha de salida</label>
                <datepicker
                  v-model="fSalida"
                  color="grey darken-4"
                  :language="languages.es"
                  :disabled="fgConsultar ? true : HojaIID > 0 && fgLlegada ? true : false"
                  format="yyyy-MM-dd"
                  :disabled-dates="disabledDates"
                ></datepicker>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5" v-show="fgHoraSalida.fgVisible">
                <label for>Hora de salida</label>
                <br />
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="time"
                  :disabled="fgConsultar ? true : HojaIID > 0 && fgLlegada ? true : false"
                />
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-show="fgHoraLlegada.fgVisible ? fgConsultar && fgLlegada ? true : fgLlegada ? true : false : false"
              >
                <label for>Hora de Llegada</label>
                <br />
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="timeLlegada"
                  :disabled="fgConsultar ? true : fgLlegada ? false : true"
                />
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-if="fgKilometrajeLlegada.fgVisible ? fgConsultar && fgLlegada ? true : fgLlegada ? true : false : false"
              >
                <label for>Kilometraje de Llegada</label>
                <vs-input
                  v-model="KilometrajeFinal"
                  class="w-full"
                  name="v_KilometrajeFinal"
                  v-validate="!KilometrajeFinal && fgKilometrajeLlegada.fgVisible && HojaIID > 0 ? 'required' : ''"
                  :required="!KilometrajeFinal"
                  :disabled="fgConsultar ? true : fgLlegada ? false : true"
                />
                <span class="text-danger">{{ errors.first('step-2.v_KilometrajeFinal') }}</span>
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-show="fgFechaLlegada.fgVisible ? fgConsultar && fgLlegada ? true : fgLlegada ? true : false : false"
              >
                <label for>Fecha de Llegada</label>
                <datepicker
                  v-model="fLlegada"
                  color="grey darken-4"
                  :language="languages.es"
                  format="yyyy-MM-dd"
                  :disabled="fgConsultar ? true : fgLlegada ? false : true"
                  :disabled-dates="disabledDates"
                ></datepicker>
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5"
                v-if="fgLitrosCargados.fgVisible ? fgConsultar && fgLlegada ? true : fgLlegada ? true : false : false"
              >
                <label for>Litros cargados</label>
                <vs-input
                  v-model="litrosCargados"
                  :disabled="fgConsultar ? true : fgLlegada ? false : true"
                />
                <!-- :required="!litrosCargados"
                  v-validate="!litrosCargados && fgLitrosCargados.fgVisible && HojaIID > 0 ? 'required' : ''"
                  class="w-full"
                  name="v_litrosCargados"
                <span class="text-danger">{{ errors.first('step-2.v_litrosCargados') }}</span>-->
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5"
                v-show="fgCombustibleInicial.fgVisible || fgMedidorCombustibleSalida.fgVisible ? true : false"
              >
                <label for>
                  Combustible de salida
                  <span
                    v-if="fgMedidorCombustibleSalida.fgVisible"
                  >: {{idCombustible.id}}%</span>
                </label>
                <ejs-lineargauge
                  v-if="fgMedidorCombustibleSalida.fgVisible"
                  style="display:block;"
                  align="left"
                  height="350px"
                  width="350px"
                  id='annotationContainer' 
                  ref="lineargauge"
                  :valueChange="PointerRender" 
                >
                  <e-axes>
                    <e-axis
                      :annotations="annotations"
                      :majorTicks="majorTicks"
                      :minorTicks="minorTicks"
                      :labelStyle="labelStyle"
                      :ranges="ranges"
                      :minimum="minimum"
                      :maximum="maximum"
                    >
                      <e-pointers>
                        <e-pointer
                          :value="idCombustible.id"
                          :height="height"
                          :width="width"
                          :offset="offset"
                          :markerType="markerType"
                          :border="border"
                          :enableDrag="fgConsultar ? false : fgLlegada ? false : enablePointerDrag"
                        ></e-pointer>
                      </e-pointers>
                    </e-axis>
                  </e-axes>
                </ejs-lineargauge>
                <v-select
                  v-if="fgCombustibleInicial.fgVisible"
                  v-model="idCombustible"
                  :options="options7"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgConsultar ? true : fgLlegada ? true : false"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idCombustible"
                      v-bind="attributes"
                      v-on="events"
                      :disabled="Activo == 1 ? true : false"
                      name="v_idCombustible"
                      v-validate="!idCombustible && fgCombustibleInicial.fgVisible ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger"
                  v-if="fgCombustibleInicial.fgVisible"
                >{{ errors.first('step-2.v_idCombustible') }}</span>
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5"
                v-show="fgCombustibleFinal.fgVisible || fgMedidorCombustibleLlegada.fgVisible ? fgConsultar && fgLlegada ? true : fgLlegada ? true : false : false"
              >
                <label for>
                  Combustible de Llegada
                  <span
                    v-if="fgMedidorCombustibleLlegada.fgVisible"
                  >: {{idCombustibleLlegada.id}}%</span>
                </label>
                <ejs-lineargauge
                  v-if="fgMedidorCombustibleLlegada.fgVisible"
                  style="display:block;"
                  align="left"
                  height="350px"
                  width="350px"
                  id='annotationContainerLL' 
                  ref="lineargaugeLL"
                  :enablePointerDrag="fgConsultar ? false : fgLlegada ? enablePointerDrag : false"
                  :dragEnd="PointerRenderLlegada"
                  :tooltip="tooltip"
                >
                  <e-axes>
                    <e-axis
                      :annotations="annotations"
                      :majorTicks="majorTicks"
                      :minorTicks="minorTicks"
                      :labelStyle="labelStyle"
                      :ranges="ranges"
                      :minimum="minimum"
                      :maximum="maximum"
                    >
                      <e-pointers>
                        <e-pointer
                          :value="idCombustibleLlegada.id"
                          :height="height"
                          :width="width"
                          :offset="offset"
                          :markerType="markerType"
                          :border="border"
                          :enableDrag="fgConsultar ? false : fgLlegada ? enablePointerDrag : false"
                        ></e-pointer>
                      </e-pointers>
                    </e-axis>
                  </e-axes>
                </ejs-lineargauge>
                <v-select
                  v-model="idCombustibleLlegada"
                  :options="options7"
                  v-if="fgCombustibleFinal.fgVisible"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="fgLlegada ? fgConsultar ? true : false : true"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idCombustibleLlegada"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idCombustibleLlegada"
                      v-validate="!idCombustibleLlegada && fgCombustibleFinal.fgVisible ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger"
                  v-if="fgCombustibleFinal.fgVisible"
                >{{ errors.first('step-2.v_idCombustibleLlegada') }}</span>
              </div>
              <!-- </div>
              <div class="vx-row">-->
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-5" v-show="fgDetalleVehiculo.fgVisible">
                <label for>Detalles del vehículo</label>
                <vs-textarea v-model="Comentarios" class="mb-0" rows="3" :disabled="fgConsultar" />
              </div>
            </div>
          </form>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Check Vehículo/Mantenible" class="mb-5" :before-change="validateStep3">
          <div class="vx-row">
            <div
              :class="seccion.Origen == (fgLlegada ? 'LLEGADA' : 'SALIDA') ? 'vx-col md:w-1/2 lg:w-1/3 sm:w-full w-full mt-5' : ''"
              v-for="(seccion, i) in CuestionarioEmpresa.Secciones"
              :key="i"
              style="position:relative"
            >
              <div 
                v-if="fgConsultar && fgLlegada ? true : CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada && fgConsultar ? true : CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && fgLlegada ? true : false"
                style="z-index: 999999999 !important;position: absolute !important;width: 100% !important;height: 100% !important;background: rgba(241,240,247, .5)"
              ></div>
              <h5
                v-if="fgConsultar ? CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && fgLlegada ? true : false : CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : (fgLlegada && HojaIID > 0) ? true : false"
              >{{seccion.NombreSeccion}}</h5>
              <hr
                class="mt-5"
                v-if="fgConsultar ? CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && fgLlegada ? true : false : CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : (fgLlegada && HojaIID > 0) ? true : false"
              />
              <vs-table
                multiple
                v-model="selected"
                :data="CuestionarioEmpresa.Secciones[i].Preguntas"
                :id="'table_' + i"
                :key="i"
                :class="'tb_' + CuestionarioEmpresa.Secciones[i].Origen + ' checklist_tb'"
                v-if="fgConsultar ? CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : fgConsultar && CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && fgLlegada ? true : false : CuestionarioEmpresa.Secciones[i].Origen == 'LLEGADA' && fgLlegada ? true : CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' && !fgLlegada ? true : (fgLlegada && HojaIID > 0) ? true : false"
              >
                <template slot="thead" :id="'thead_' + i" class="tb_check_vehiculo">
                  <tr>
                    <th style="display:none"></th>
                    <th>Seleccionar</th>
                  </tr>
                  <!-- <vs-th>Seleccionar todos</vs-th> -->
                </template>

                <template slot-scope="{data}">
                  <vs-tr
                    :data="tr"
                    v-show="tr.TipoPreguntaID == 2? false : true"
                    :key="tr.TipoPreguntaID == 2 ? 'Otro' : indextr+'_'+i"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td
                      :data="data[indextr].PreguntaID"
                      :id="CuestionarioEmpresa.Secciones[i].Origen + '_' +indextr"
                    >{{data[indextr].Pregunta}}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div
                class="vx-col w-full mt-5"
                v-show="tr2.TipoPreguntaID == 2 ? CuestionarioEmpresa.Secciones[i].Origen == 'SALIDA' ? true : fgLlegada ? true : false : false"
                :key="indext"
                v-for="(tr2, indext) in CuestionarioEmpresa.Secciones[i].Preguntas"
              >
                <label>Otro</label>
                <vs-input v-model="Otro[i]" v-on:change="changeOtros(tr2, i)" class="w-full" />
              </div>
            </div>
          </div>
        </tab-content>

        <!-- tab 4 content -->
        <tab-content title="Detalles del Vehículo/Mantenible" class="mb-5" :before-change="validateStep4">
          <div class="vx-row">
            <div class="vx-col w-full">
              <span
                class="material-icons"
                style="font-size:24px; color:#ea728c;vertical-align: bottom;"
              >fiber_manual_record</span>
              <span style="color:black">Abolladura</span>
              <span
                class="material-icons"
                style="font-size:24px; color:#baf1a1; vertical-align: bottom;"
              >fiber_manual_record</span> Rayón
              <span
                class="material-icons"
                style="font-size:24px; color:#459CD2;vertical-align: bottom;"
              >fiber_manual_record</span> Daño genérico
            </div>
          </div>
          <hr class="my-3" />
          <div class="vx-row">
            <vx-card style="min-width:800px">
              <div class="vx-row">
                <div class="vx-col md:w-full lg:w-1/2 w-full">
                  <!-- <img :src="card_1.img" alt="content-img" class="responsive card-img-top"> -->
                  <!-- <div
                    @click="getCordenadas"
                    id="img-element"
                    aspect-ratio="1"
                    :style="'width:600px;height: 300px;background-image: url(' + imgCarro + ');background-position: center center;background-size: contain;background-repeat: no-repeat;'"
                  ></div>-->
                  <img
                    v-bind:src="imgCarro"
                    aspect-ratio="1"
                    class
                    style="border:2px gray solid;width:600px; height: 300px;"
                    draggable="false"
                    @click="getCordenadas"
                    id="img-element"
                  />
                  <div v-html="svgTest" ref="incomingDef"></div>
                  <div v-html="pointOne" ref="incomingDef"></div>
                  <div v-html="pointTwo" ref="incomingDef"></div>
                  <div v-html="pointThre" ref="incomingDef"></div>
                  <div v-html="pointFor" ref="incomingDef"></div>
                  <div v-html="pointFive" ref="incomingDef"></div>
                  <div v-html="pointSix" ref="incomingDef"></div>
                  <div v-html="pointSeven" ref="incomingDef"></div>
                  <div v-html="pointEigth" ref="incomingDef"></div>
                  <div v-html="pointNine" ref="incomingDef"></div>
                  <div v-html="pointTen" ref="incomingDef"></div>
                  <div v-html="pointEleven" ref="incomingDef"></div>
                  <div v-html="pointTwelve" ref="incomingDef"></div>
                  <div v-html="pointThirteen" ref="incomingDef"></div>
                  <div v-html="pointFourTeen" ref="incomingDef"></div>
                  <div v-html="pointFifTeen" ref="incomingDef"></div>
                  <div v-html="pointSixTeen" ref="incomingDef"></div>
                  <div v-html="pointSevenTeen" ref="incomingDef"></div>
                  <div v-html="pointEigthTeen" ref="incomingDef"></div>
                  <div v-html="pointNineTeen" ref="incomingDef"></div>
                  <div v-html="pointTwenty" ref="incomingDef"></div>
                  <div class="vx-row">
                    <div class="vx-col w-full">{{ tituloIMG }}</div>
                    <vs-button
                      color="primary"
                      class="w-1/2 mt-5"
                      type="border"
                      icon-pack="feather"
                      icon="icon-next"
                      :disabled="arregloImgsCarro.length > 0 ? false : true"
                      v-on:click="antImg()"
                    >Anterior</vs-button>
                    <vs-button
                      color="primary"
                      class="w-1/2 mt-5"
                      type="border"
                      icon-pack="feather"
                      icon="icon-plus"
                      :disabled="arregloImgsCarro.length > 0 ? false : true"
                      v-on:click="sigImg()"
                    >Siguiente</vs-button>
                  </div>
                </div>
                <div class="vx-col md:w-full lg:w-1/2 w-full">
                  <h5>Detalles del Vehículo/Mantenible</h5>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="vx-row" v-if="fgConsultar ? false: true">
                        <div class="vx-col md:w-1/3">
                          <label for>Nombre del detalle</label>
                          <vs-input
                            v-model="namePoint"
                            class="w-full"
                            maxlength="250"
                            hint="Ingrese el nombre del detalle"
                          />
                        </div>
                        <div class="vx-col md:w-1/3">
                          <label for>Tipo de detalle</label>
                          <v-select
                            v-model="tipoAveriaID"
                            :options="tipoAverias"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          />
                        </div>
                        <div class="vx-col md:w-1/3">
                          <vs-button
                            color="success"
                            class="w-full mt-5"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus"
                            v-on:click="marketPoint()"
                            :disabled="arregloImgsCarro.length > 0 ? false : true"
                          >Agregar</vs-button>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full">
                      <hr class="my-3" />
                      <vs-table :data="pointsMarker" :max-items="100" search ref="table">
                        <template slot="thead">
                          <vs-th sort-key="Numero">#</vs-th>
                          <vs-th sort-key="Detalle">NOMBRE</vs-th>
                          <vs-th sort-key="AveriaName">TIPO</vs-th>
                          <vs-th sort-key="Nombre">IMAGEN</vs-th>
                          <vs-th sort-key="FechaRegistro">FECHA</vs-th>
                          <vs-th>ORIGEN</vs-th>
                          <vs-th >OPT</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index" v-for="(items, index) in data">
                            <vs-td :data="data[index].Numero">{{data[index].Numero}}</vs-td>
                            <vs-td :data="data[index].Detalle">{{data[index].Detalle}}</vs-td>
                            <vs-td :data="data[index].AveriaName">{{data[index].AveriaName}}</vs-td>
                            <vs-td>{{data[index].Nombre}}</vs-td>
                            <vs-td :data="data[index].FechaRegistro">{{data[index].FechaRegistro}}</vs-td>
                            <vs-td>
                              <vs-chip
                                :title="data[index].Origen"
                                :color="data[index].Origen == 'SALIDA' || data[index].Origen == '' ? '#24c1a0' : 'dark'"
                              >{{data[index].Origen == 'SALIDA' ? 'SL' : 'LL'}}</vs-chip>
                            </vs-td>
                            <vs-td class="whitespace-no-wrap">
                              <feather-icon
                                icon="TrashIcon"
                                :svgClasses="'w-5 h-5 stroke-current ' + (data[index].AveriaID > 0 && !fgLlegada ? 'text-gray' : 'hover:text-danger')"
                                class="ml-2"
                                :style="(data[index].AveriaID > 0 && fgLlegada && data[index].Origen == 'SALIDA') || fgConsultar || (data[index].AveriaID > 0 && HojaIID == 0 && data[index].Origen == 'SALIDA') ? 'cursor:not-allowed' : ''"
                                @click.stop="(data[index].AveriaID > 0 && fgLlegada && data[index].Origen == 'SALIDA') || fgConsultar || (data[index].AveriaID > 0 && HojaIID == 0 && data[index].Origen == 'SALIDA') ? '' : deletePoint(index)"
                              />
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </tab-content>

        <!-- tab 5 content -->
        <tab-content
          title="Firmas"
          class="mb-5"
          :before-change="validateStep5"
          v-if="ArrayFirmas.length > 0 ? true : false"
        >
          <div class="vx-row">
            <div
              :class="'sm:w-full w-full p-2 ' + (!fgLlegada ? 'md:w-full lg:w-full' : 'md:w-1/2 lg:w-1/2')"
              style="position:relative"
            >
              <h5>FIRMAS DE SALIDA</h5>
              <hr class="mt-5" />
              <div
                v-if="fgLlegada ? true : fgConsultar ? true : false"
                style="z-index: 999999999 !important;position: absolute !important;width: 100% !important;height: 100% !important;background: rgba(241,240,247, .5);top:0"
              ></div>
              <div class="vx-col w-full" :key="index" v-for="(item, index) in ArrayFirmas">
                <vx-card class="mb-5" v-if="item.Origen == 'SALIDA'">
                  <h5>{{ArrayFirmas[index].Nombre}}</h5>
                  <div class="vx-row">
                    <div class="vx-col w-full mt-3">
                      <label for>Nombre</label>
                      <v-select
                        v-model="ArrayFirmas[index].lsFirmas[0].Nombre"
                        :options="item.lsResponsables"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      >
                        <template #no-options="{  }">No se encontraron resultados.</template>
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                        </template>
                      </v-select>
                    </div>
                    <div class="vx-col w-full mt-3">
                      <label for>Firma</label>
                      <VueSignaturePad
                        :id="'signature'+ index"
                        class="signature_pad"
                        width="100%"
                        height="300px"
                        :ref="'signaturePad_salida'"
                        :options="options"
                        :disabled="fgConsultar == 1 ? true : false"
                      />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                      <vs-button
                        type="border"
                        color="warning"
                        class="w-full"
                        v-on:click="fgConsultar ? '' : undo(index, 1)"
                      >Revertir</vs-button>
                    </div>
                    <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                      <vs-button
                        type="border"
                        color="danger"
                        class="w-full"
                        v-on:click="fgConsultar ? '' : Clear(index, 1)"
                      >Borrar Todo</vs-button>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div
              class="md:w-1/2 lg:w-1/2 sm:w-full w-full p-2"
              v-if="fgLlegada"
              style="position:relative"
            >
              <h5>FIRMAS DE LLEGADA</h5>
              <hr class="mt-5" />
              <div
                v-if="fgConsultar"
                style="z-index: 999999999 !important;position: absolute !important;width: 100% !important;height: 100% !important;background: rgba(241,240,247, .5); top:0"
              ></div>
              <div class="vx-col w-full" :key="index" v-for="(item, index) in ArrayFirmas">
                <vx-card class="mb-5" v-if="item.Origen == 'LLEGADA'">
                  <h5>{{ArrayFirmas[index].Nombre}}</h5>
                  <div class="vx-row">
                    <div class="vx-col w-full mt-3">
                      <label for>Nombre</label>
                      <v-select
                        v-model="ArrayFirmas[index].lsFirmas[((item.Origen == null) ? 1 : 0)].Nombre"
                        :options="item.lsResponsables"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      >
                        <template #no-options="{  }">No se encontraron resultados.</template>
                        <template #search="{attributes, events}">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                        </template>
                      </v-select>
                    </div>
                    <div class="vx-col w-full mt-3">
                      <label for>Firma</label>
                      <VueSignaturePad
                        :id="'signature'+ index"
                        class="signature_pad"
                        width="100%"
                        height="300px"
                        :ref="'signaturePad'"
                        :options="options"
                        :disabled="Activo == 1 ? true : false"
                      />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                      <vs-button
                        type="border"
                        color="warning"
                        class="w-full"
                        v-on:click="fgConsultar ? '' : undo(index, 2)"
                      >Revertir</vs-button>
                    </div>
                    <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                      <vs-button
                        type="border"
                        color="danger"
                        class="w-full"
                        v-on:click="fgConsultar ? '' : Clear(index, 2)"
                      >Borrar Todo</vs-button>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </vs-popup>
    <vs-popup :title="titlePopupIncidencia" :active.sync="popupActiveIncidencia">
      <form-wizard
        ref="wizard3"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        :finishButtonText="dataForm.lsAllIncidencias.length == 0 ? 'Cerrar' : 'Guardar'"
        nextButtonText="Siguiente"
        backButtonText="Regresar"
        @on-complete="dataForm.lsAllIncidencias.length == 0 ? cancelFormPopup() : formSubmittedIncidencia()"
      >
        <tab-content title="Datos generales" class="mb-5" :before-change="validateStep1Incidencia">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1-incidencia">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5">
                <label for>Fecha de registro</label>               
                <br />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5">
                <datepicker
                v-model="dataForm.FechaRegistro"
                color="grey darken-4"
                :language="languages.es"
                format="yyyy-MM-dd"
                :disabled="true"
              ></datepicker>               
              </div>        
            </div>          
            <div class="vx-row">
                <div class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5">
                    <label for>Vehículo/Mantenible</label>               
                    <br />
                </div>
                <div class="vx-col md:w-1/2 lg:w-1/2 w-full mt-5">
                    <vs-input
                    v-model="dataForm.Vehiculo"
                    class="w-full"
                    maxlength="250"
                    :disabled="true"
                    />
                </div>    
            </div>     
            <div class="vx-row">
              <div class="vx-col w-full mt-5">
                <vs-checkbox v-model="dataForm.EstatusVehiculo">Marcar vehículo como No Disponible</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-5" style="height:250px;overflow-y:scroll">
                <vs-table
                  multiple
                  v-model="dataForm.Incidencias"
                  :data="dataForm.lsAllIncidencias" 
                  noDataText="" 
                  :max-items="100" search              
                >
                <!-- <template slot="no-data">
                  <v-alert :value="true" color="error" icon="warning">
                    Sorry, nothing to display here :(
                  </v-alert>
                </template> -->
                  <template slot="thead" class="tb_check_vehiculo">
                    <tr>
                      <th style="display:none"></th>
                      <th>{{dataForm.lsAllIncidencias.length > 0 ? 'Seleccionar Detalle' : 'No se encontraron Detalles'}}</th>
                    </tr>
                    <!-- <vs-th>Seleccionar todos</vs-th> -->
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"                      
                    >                    
                      <vs-td
                        :data="data[indextr].AveriaID"
                      >{{data[indextr].Detalle}}, <b>{{(data[indextr].TipoAveria == 1 ? "RAYON" : data[indextr].TipoAveria == 2 ? "ABOLLADURA" : "DAÑO GENERICO")}}</b></vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="vx-row" v-if="dataForm.lsAllIncidenciasGenerada.length > 0 ? true : false">
              <div class="vx-col w-full mt-5" style="height:250px;overflow-y:scroll">
                <vs-table
                  :data="dataForm.lsAllIncidenciasGenerada"                  
                >
                  <template slot="thead" class="tb_check_vehiculo">
                    <tr>
                      <th colspan="3">Detalle(s) ya generado(s) como INCIDENCIA</th>
                    </tr>
                    <!-- <vs-th>Seleccionar todos</vs-th> -->
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >                    
                      <vs-td
                        :data="data[indextr].AveriaID"
                      >
                        <b>{{data[indextr].Folio}}</b> - {{data[indextr].Nombre.replace((data[indextr].TipoAveria == 1 ? "RAYON" : data[indextr].TipoAveria == 2 ? "ABOLLADURA" : "DAÑO GENERICO"), "")}}
                        <b>{{(data[indextr].TipoAveria == 1 ? "RAYON" : data[indextr].TipoAveria == 2 ? "ABOLLADURA" : "DAÑO GENERICO")}}</b>
                      </vs-td>
                      <vs-td>
                        <feather-icon
                          icon="TrashIcon"
                          :svgClasses="'w-5 h-5 stroke-current hover:text-danger'"
                          class="ml-2"
                          v-if="data[indextr].AplicaOrden > 0 ? false : true"
                          @click.stop="EliminarIncidencia(data[indextr].IncidenciaVehiculoDetalleID)"
                        />
                      </vs-td>
                      <vs-td>
                        <feather-icon
                          icon="PrinterIcon"
                          :svgClasses="'w-5 h-5 stroke-current hover:text-primary'"
                          class="ml-2"                          
                          @click.stop="ImprimirIncidencia(data[indextr].IncidenciaVehiculoID)"
                        />
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </form>
        </tab-content>
        <template slot="custom-buttons-right">
          <wizard-button class="green-btn">
              <button
              class="wizard-btn"
              v-on:click="cancelFormPopup()"
              style="background-color: rgba(var(--vs-danger), 1); border-color: rgba(var(--vs-danger), 1); color: white;"
            >Cancelar</button>              
          </wizard-button>
      </template>
      </form-wizard>
    </vs-popup>
    <vs-popup width="550px" title="Eliminar detalle de Incidencia" :active.sync="active2">
        <div class="con-content">
          <p>
            ¿Está seguro que desea eliminar el detalle de la incidencia?
          </p>
        </div>

        <div class="con-footer float-right mt-5">
            <vs-button @click="acceptDelete" transparent color="danger" type="filled">
              Aceptar
            </vs-button>
            <vs-button @click="cancelConfirm" dark transparent color="danger" type="border">
              Cancelar
            </vs-button>
          </div>
      </vs-popup>
  </vx-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
// import AgGridTable from "@/components/ag-grid-table/AgGridTable.vue";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import * as lang from "vuejs-datepicker/src/locale";
import $ from "jquery";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import authConfig from "@/../auth_config.json";
import {
  Annotations 
} from "@syncfusion/ej2-vue-lineargauge";

//const dict = FieldsValidate;
// register custom messages
//Validator.localize("en", dict);

export default {
  data() {
    return {
      //CAMPOS ACTIVADOS
      fgChecklistW: { Campo: "ChecklistW", fgVisible: true },
      fgCliente: { Campo: "Cliente", fgVisible: true },
      fgNombreCliente: { Campo: "Nombre", fgVisible: true },
      fgTipoDocumento: { Campo: "TipoDocumento", fgVisible: true },
      fgTipoVehiculo: { Campo: "TipoVehiculo", fgVisible: true },
      fgVehiculo: { Campo: "Vehiculo", fgVisible: true },
      fgTipoChasis: { Campo: "TipoChasis", fgVisible: true },
      fgEstacion: { Campo: "Estacion", fgVisible: true },
      fgInspector: { Campo: "Inspector", fgVisible: true },
      fgContrato: { Campo: "Contrato", fgVisible: true },
      fgFactura: { Campo: "Factura", fgVisible: true },
      fgTipoCombustible: { Campo: "TipoCombustible", fgVisible: true },
      fgCombustibleInicial: { Campo: "CombustibleInicial", fgVisible: true },
      fgCombustibleFinal: { Campo: "CombustibleFinal", fgVisible: true },
      fgOperador: { Campo: "Operador", fgVisible: true },
      fgAyudante: { Campo: "Ayudante", fgVisible: true },
      fgMedidorCombustibleSalida: {
        Campo: "MedidorCombustibleSalida",
        fgVisible: true,
      },
      fgMedidorCombustibleLlegada: {
        Campo: "MedidorCombustibleLlegada",
        fgVisible: true,
      },
      fgFechaSalida: { Campo: "FechaSalida", fgVisible: true },
      fgHoraSalida: { Campo: "HoraSalida", fgVisible: true },
      fgKilometrajeSalida: { Campo: "KilometrajeSalida", fgVisible: true },
      fgFechaLlegada: { Campo: "FechaLlegada", fgVisible: true },
      fgHoraLlegada: { Campo: "HoraLlegada", fgVisible: true },
      fgKilometrajeLlegada: { Campo: "KilometrajeLlegada", fgVisible: true },
      fgLitrosCargados: { Campo: "LitrosCargados", fgVisible: true },
      fgDetalleVehiculo: { Campo: "DetalleVehiculo", fgVisible: true },
      Activo: 0,
      Otro: [],
      Otros: [],
      ActiveHI: true,
      active2: false,
      //Incidencia
      titlePopupIncidencia: "",
      popupActiveIncidencia: false,
      IncidenciasAsociadas: [
        { id: "0", label: "Sin Incidencia" },
        { id: "1", label: "Con Incidencia" },
      ],
      vIncidencia : "",
      
      dataForm:{
        HojaInspeccionID: 0,
        FechaRegistro: new Date(),
        Vehiculo: "",
        Folio: 0,
        Anio: new Date().getFullYear(),
        EstatusVehiculo: false,
        Incidencias:[],
        lsAllIncidencias: [],
        lsAllIncidenciasGenerada: []
      },
      emptyDataForm:{
        HojaInspeccionID: 0,
        FechaRegistro: new Date(),
        Vehiculo: "",
        Folio: 0,
        Anio: new Date().getFullYear(),
        EstatusVehiculo: false,
        Incidencias:[],
        lsAllIncidencias: [],
        lsAllIncidenciasGenerada: []
      },

      objIncidencia:{},

      //Datos generales
      FiltroAveria: 0,
      vBusquedaVehiculo:"",
      vBusquedaAveria:"",
      PerfilID: authConfig.PerfilEmpleado.PerfilID,
      HojaIID: 0,
      datos: {
        columnDefs: [],
      },
      titlePopup: "",
      renderForm: true,
      fgReportes: true,
      fgLlegada: false,
      fgConsultar: false,
      popupActive: false,
      languages: lang,
      title: "Número de viajes marcado como tienda al mes",
      fcalendarEdit: new Date(),
      fcalendarFinal: new Date().setDate(new Date().getDate() + 1),
      renderComponents: true,
      fgVisibleLlanta: false,
      LsVehiculos: [],
      LsAllVehiculos: [],
      LsLlantas: [],
      CuestionarioEmpresa: {},
      selected: [],
      pointsMarker: [],
      arregloImgsCarro: [],
      disabledDates: {
        to: new Date(Date.now()),
      },
      options: {
        penColor: "#000",
      },
      default: require("@/assets/images/vehiculos/default.png"),

      //Odometro Start
      annotations: [
        {
            content: '<div id="lowText"><p style="font-size:15px;color:#248622;">E</p></div>',
            axisIndex: 0, zIndex: '1',
            axisValue: 0,
            y: 20
        },
        {
            content: '<div id="moderateText"><p style="font-size:15px;color:#ba9e2a;">1/2</p></div>',
            axisIndex: 0, zIndex: '1',
            axisValue: 50,
            y: 50
        },
        {
            content: '<div id="highText"><p style="font-size:15px;color:#b42f2f;">FULL</p></div>',
            axisIndex: 0, zIndex: '1',
            axisValue: 75,
            y: 100
        }
      ],
      // gaugeradius: "90%",
      // startAngle: 240,
      // endAngle: 120,
      // lineStyle: {
      //   width: 0,
      // },
      // majorTicks: {
      //   color: "white",
      //   offset: -5,
      //   height: 12,
      // },
      // minorTicks: {
      //   width: 0,
      // },
      // labelStyle: {
      //   useRangeColor: true,
      //   font: {
      //     color: "#424242",
      //     size: "13px",
      //     fontFamily: "Roboto",
      //   },
      // },
      // value: 0,
      // pointerRadius: "60%",
      // color: "#33BCBD",
      // cap: {
      //   radius: 10,
      //   border: {
      //     color: "#33BCBD",
      //     width: 5,
      //   },
      // },
      // animation: {
      //   enable: true,
      //   duration: 1500,
      // },
      // ranges: [
      //   {
      //     start: 0,
      //     end: 50,
      //     startWidth: 10,
      //     endWidth: 10,
      //     radius: "102%",
      //     color: "#3A5DC8",
      //   },
      //   {
      //     start: 50,
      //     end: 120,
      //     radius: "102%",
      //     startWidth: 10,
      //     endWidth: 10,
      //     color: "#33BCBD",
      //   },
      // ],
      // tooltip: {
      //   type: ["Pointer", "Range", "Annotation"],
      //   enable: true,
      //   enableAnimation: false,
      //   annotationSettings: { template: "<div>lineargauge</div>" },
      //   rangeSettings: { fill: "red" },
      // },
      enablePointerDrag: true,
      orientation: "Vertical",
      minimum: 0,
      maximum: 100,
      value: 0,
      height: 33,
      width: 55,
      offset: -85,
      markerType: "Triangle",
      border: {
        width: 2,
        color: "white"
      },
      majorTicks: {
        height: 0,
        width: 0,
        interval: 20
      },
      minorTicks: {
        height: 7,
        width: 0,
        interval: 4
      },
      labelStyle: {
        position: "Outside",
        font: {
          color: "red",
          size: '0px'
        },
        //format: '{value === 0 ? "E" : value} %%%',
        offset: 4
      },
      ranges: [
        {
          start: 0,
          end: 11,
          startWidth: 79,
          endWidth: 79,
          color: "#FF2E32"
        },
        {
          start: 11,
          end: 22,
          startWidth: 79,
          endWidth: 79,
          color: "#FF5E29"
        },
        {
          start: 22,
          end: 33,
          startWidth: 79,
          endWidth: 79,
          color: "#FF9100"
        },
        {
          start: 33,
          end: 44,
          startWidth: 79,
          endWidth: 79,
          color: "#FFC200"
        },
        {
          start: 44,
          end: 55,
          startWidth: 79,
          endWidth: 79,
          color: "#FFED00"
        },
        {
          start: 55,
          end: 66,
          startWidth: 79,
          endWidth: 79,
          color: "#D3E400"
        },
        {
          start: 66,
          end: 77,
          startWidth: 79,
          endWidth: 79,
          color: "#99D400"
        },
        {
          start: 77,
          end: 88,
          startWidth: 79,
          endWidth: 79,
          color: "#58CC0A"
        },
        {
          start: 88,
          end: 100,
          startWidth: 79,
          endWidth: 79,
          color: "#00C117"
        }
      ],

      isPrimary: true,
      content1: "Print",
      content: "Export",
      modedata: ["JPEG", "PNG", "SVG", "PDF"],
      cssClass: "e-flat",
      iconCss: "e-icons e-play-icon",
      iconCss1: "e-icons e-play-icon1",  
      //Odometro END

      //Fields Step 1
      idCliente: 0,
      options1: [],
      Nombre: "",
      idTipoDocumento: 0,
      options2: [],
      idTipoChasis: 0,
      options3: [
        { id: 1, label: "CRAFTER C/CAJA" },
        { id: 2, label: "CRAFTER VAN" },
        { id: 3, label: "FL-360" },
        { id: 4, label: "FL-M2" },
        { id: 5, label: "HINO 300" },
        { id: 6, label: "HINO 500" },
        { id: 7, label: "HINO HIBRIDA" },
        { id: 8, label: "SPRINTER C/CAJA" },
        { id: 9, label: "SPRINTER VAN" },
        { id: 10, label: "UTILITARIO" },
      ],
      Contrato: "",
      Factura: "",
      idVehiculo: 0,
      options4: [],
      idTipoVehiculo: 0,
      TiposVehiculos: [],
      idEstacion: 0,
      options5: [],
      MarcaModelo: "",
      Descripcion: "",
      Placa: "",
      idEmpleado: 0,
      options6: [],
      idOperador: 0,
      optionsO: [],
      optionsA: [],
      idAyudante: [],

      //Fields Step 2
      options7: [
        { id: "Empty", label: "Empty" },
        { id: "1/16", label: "1/16" },
        { id: "1/8", label: "1/8" },
        { id: "3/16", label: "3/16" },
        { id: "1/4", label: "1/4" },
        { id: "5/16", label: "5/16" },
        { id: "3/8", label: "3/8" },
        { id: "7/16", label: "7/16" },
        { id: "1/2", label: "1/2" },
        { id: "9/16", label: "9/16" },
        { id: "5/8", label: "5/8" },
        { id: "11/16", label: "11/16" },
        { id: "3/4", label: "3/4" },
        { id: "13/16", label: "13/16" },
        { id: "7/8", label: "7/8" },
        { id: "15/16", label: "15/16" },
        { id: "Full", label: "Full" },
      ],
      idCombustible: { id: 0, label: "Empty" },
      idCombustibleLlegada: { id: 0, label: "Empty" }, //NUEVO
      dataCombustible: {},
      idTipoCombustible: 0,
      options8: [],
      Kilometraje: "",
      KilometrajeEdicion: 0,
      KilometrajeFinal: "", //NUEVO
      litrosCargados: "", //NUEVO
      fLlegada: new Date(), //NUEVO
      fSalida: new Date(),
      time: new Date().getHours() + ":" + new Date().getMinutes(),
      timeLlegada: new Date().getHours() + ":" + new Date().getMinutes(), //NUEVO
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "H:i",
      },
      Comentarios: "",

      //Step 4
      imgCarro: "",
      svgTest: null,
      py: 0,
      px: 0,
      valorimg: 0,
      tituloIMG: "FRONTAL",
      indiceCurrent: 0,
      image_width: 0,
      image_height: 0,
      indiceImg: 0,
      msjException: false,
      msjAlerta: "",
      namePoint: null,
      pointOne: null,
      pointTwo: null,
      pointThre: null,
      pointFor: null,
      pointFive: null,
      pointSix: null,
      pointSeven: null,
      pointEigth: null,
      pointNine: null,
      pointTen: null,
      pointEleven: null,
      pointTwelve: null,
      pointThirteen: null,
      pointFourTeen: null,
      pointFifTeen: null,
      pointSixTeen: null,
      pointSevenTeen: null,
      pointEigthTeen: null,
      pointNineTeen: null,
      pointTwenty: null,
      tipoAveriaID: 0,
      tipoAverias: [
        { id: 1, label: "RAYON" },
        { id: 2, label: "ABOLLADURA" },
        { id: 3, label: "DAÑO GENERICO" },
      ],

      //step5
      ArrayFirmas: [],
      //Modo de la hoja de inspeccion
      HojaInspeccionModoEdicion:false
    };
  },
  components: {
    AgGridVue,
    Datepicker,
    FormWizard,
    "v-select": vSelect,
    TabContent,
    flatPickr,
  },
  computed: {},
  watch: {
    //Activo(val) {
    // if (val == 1) {
    //   // $("tr.is-selected").prop(
    //   //   "style",
    //   //   "background: rgba(241,240,247,.5) !important;"
    //   // );
    // } else {

    // }
    //},
    fcalendarFinal(val) {
      let Inicio = new Date(this.fcalendarEdit);
      let Final = new Date(val);
      //console.log(new Date(val));
      if (Final < Inicio) {
        this.fcalendarEdit = this.fcalendarFinal;
      }
    },
    fcalendarEdit(val) {
      let Final = new Date(this.fcalendarFinal);
      let Inicio = new Date(val);

      if (Inicio > Final) {
        this.fcalendarFinal = this.fcalendarEdit;
      }
    },
    idVehiculo(val) {
      if (val != "") {
        const datosVehiculo = this.LsVehiculos.filter((vehiculo) => {
          if (vehiculo.VehiculoID === val.id) {
            return vehiculo;
          }
        });

        //console.log(datosVehiculo);
        this.fgVisibleLlanta = true;
        this.MarcaModelo =
          datosVehiculo[0].Marca + "-" + datosVehiculo[0].Modelo;
        this.Placa = datosVehiculo[0].Placa;
        this.Descripcion = datosVehiculo[0].Descripcion;
        if (this.HojaIID == 0) {
          this.options8 = [
            {
              id:
                datosVehiculo[0].TiposCombustible != null
                  ? datosVehiculo[0].TiposCombustible.ID
                  : null,
              label:
                datosVehiculo[0].TiposCombustible != null
                  ? datosVehiculo[0].TiposCombustible.Nombre
                  : null,
            },
          ];
          this.idTipoCombustible =
            datosVehiculo[0].TiposCombustible != null
              ? this.options8.filter((obj) => {
                  if (obj.id == datosVehiculo[0].TiposCombustible.ID) {
                    return obj;
                  }
                })[0]
              : { id: null, label: null };
        }
        //this..estacionDuenia = datosVehiculo[0].Propietario.Nombre
        if (this.HojaIID == 0 && !this.fgConsultar) {
          this.Kilometraje = parseFloat(
            datosVehiculo[0].Odometro == null
              ? 0
              : datosVehiculo[0].Odometro
          ).FormatMiles(); //
        }
        
        //if(!this.fgLlegada && this.HojaIID == 0){
          this.getLlantasVehiculo(datosVehiculo[0].VehiculoID);
        //}
        this.getAveriasNoAtendidasByVehiculo(datosVehiculo[0].VehiculoID);
        
        if (this.fgOperador.fgVisible) {
          this.getOperadoresVehiculo(datosVehiculo[0].VehiculoID);
        }
      }
    },
    idTipoVehiculo(obj) {
      //console.log(obj);
      if (obj != null && obj != "" && obj.id > 0) {
        this.arregloImgsCarro = [];
        if (this.HojaIID == 0 && !this.fgConsultar) {
          this.pointsMarker = [];
        }
        this.$vs.loading();

        if (obj.Fotos.length > 0) {
          for (var i in obj.Fotos) {
            if (obj.Fotos[i].Orden < 5) {
              this.arregloImgsCarro.push({
                img: obj.Fotos[i].ImagenUrl,
                indice: obj.Fotos[i].Orden,
                id: obj.Fotos[i].TipoVehiculoFotoID,
                titulo:
                  obj.Fotos[i].Orden == 1
                    ? "FRONTAL"
                    : obj.Fotos[i].Orden == 2
                    ? "TRASERA"
                    : obj.Fotos[i].Orden == 3
                    ? "LATERAL DER"
                    : "LATERAL IZQ",
                TipoVehiculoID: obj.Fotos[i].TipoVehiculoID,
              });
            }
          }

          this.imgCarro = this.arregloImgsCarro[0].img;
        } else {
          this.$vs.notify({
            color: "danger",
            time: 15000,
            title: "Alerta",
            text:
              "El tipo de vehículo " +
              obj.label +
              " no tiene imágenes de detalles del vehículo asignados.",
          });

          this.imgCarro = this.default;
        }

        this.getVehiculosByTipo(obj.id); //
        this.getCuestionario(obj);
        //console.log("Aquí debería consultar");
        //console.log(obj);
        setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
      }
    },
    Kilometraje(New) {
      //console.log(New);
      this.Kilometraje =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    KilometrajeFinal(New) {
      this.KilometrajeFinal =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    litrosCargados(New) {
      this.litrosCargados =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "")
              .replace(/([0-9])([0-9]{2})$/, "$1.$2")
              .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    popupActiveIncidencia(fg){
      if(fg == false){
        this.clearFormIncidencia();
      }
    },
    popupActive(fg) {
      //console.log(this.$refs.wizard);
      this.$refs.wizard.reset();
    //console.log(fg)      ;
      if (fg == false) {
        this.Activo = 0;
        this.fgConsultar = false;
        this.fgLlegada = false;
        this.HojaIID = 0;
        this.PerfilID = authConfig.PerfilEmpleado.PerfilID;
        this.Otro = [];
        this.Otros = [];
        this.idAyudante = [];
        this.idOperador = 0;
        if (this.ArrayFirmas.length > 0) {
          for (var i in this.ArrayFirmas) {
            if (this.HojaIID > 0) {
              this.$refs.signaturePad[i].clearSignature();
            }
            this.$refs.signaturePad_salida[i].clearSignature();
            for (var index in this.ArrayFirmas[i].lsFirmas) {
              this.ArrayFirmas[i].lsFirmas[index].Firma = null;
              this.ArrayFirmas[i].lsFirmas[index].Nombre = null;
              this.ArrayFirmas[i].lsFirmas[index].FirmaReporteID = 0;
              this.ArrayFirmas[i].lsFirmas[index].HojaInspeccionID = null;
              this.ArrayFirmas[i].lsFirmas[index].HojaRecepcionID = null;
            }
          }
        }
        
        this.errors.clear();
        this.idCliente = this.fgCliente.fgVisible ? "" : "Empty";
        this.Nombre = this.fgNombreCliente.fgVisible ? "" : "Empty";
        this.idTipoDocumento = this.fgTipoDocumento.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.idTipoChasis = this.fgTipoChasis.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.Contrato = this.fgContrato.fgVisible ? "" : "Empty";
        this.Factura = this.fgFactura.fgVisible ? "" : "Empty";
        this.idVehiculo = this.fgVehiculo.fgVisible ? "" : { id: 0, label: "" };
        this.idTipoVehiculo = { id: 0, label: "" };
        this.idEstacion = this.fgEstacion.fgVisible ? "" : { id: 0, label: "" };
        this.Descripcion = "";
        this.MarcaModelo = "";
        this.idEmpleado = this.fgInspector.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.Placa = "";
        this.LsLlantas = [];
        this.fgVisibleLlanta = false;
        this.idCombustible = this.fgCombustibleInicial.fgVisible
          ? { id: 0, label: "" }
          : { id: 0, label: "" };
        this.idTipoCombustible = this.options8[0];
        this.Comentarios = "";
        this.idCombustibleLlegada = { id: 0, label: "" };
        this.Kilometraje = this.fgKilometrajeSalida.fgVisible ? "" : 0;
        this.KilometrajeEdicion = 0;
        this.KilometrajeFinal = this.fgKilometrajeLlegada.fgVisible ? "" : 0;
        this.litrosCargados = this.fgLitrosCargados.fgVisible ? "" : 0;
        (this.fSalida = new Date()),
          (this.time = new Date().getHours() + ":" + new Date().getMinutes()),
          this.errors.clear();
        this.selected = [];
        this.imgCarro = "";
        this.svgTest = null;
        this.py = 0;
        this.px = 0;
        this.valorimg = 0;
        this.tituloIMG = "FRONTAL";
        this.indiceCurrent = 0;
        this.image_width = 0;
        this.image_height = 0;
        this.indiceImg = 0;
        this.msjException = false;
        this.msjAlerta = "";
        this.namePoint = null;
        this.pointOne = null;
        this.pointTwo = null;
        this.pointThre = null;
        this.pointFor = null;
        this.pointFive = null;
        this.pointSix = null;
        this.pointSeven = null;
        this.pointEigth = null;
        this.pointNine = null;
        this.pointTen = null;
        this.pointEleven = null;
        this.pointTwelve = null;
        this.pointThirteen = null;
        this.pointFourTeen = null;
        this.pointFifTeen = null;
        this.pointSixTeen = null;
        this.pointSevenTeen = null;
        this.pointEigthTeen = null;
        this.pointNineTeen = null;
        this.pointTwenty = null;
        this.tipoAveriaID = null;
        this.pointsMarker = [];

        setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
      }
      this.errors.clear();
    },
  },
  created() {
    if (authConfig.EmpresaId > 0) {
      this.getCamposHojaInspeccion();
      this.getCamposFirmas();
    } else {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {
    if (authConfig.EmpresaId > 0) {
      this.getClientes();
      this.getSucursales();
      this.getTiposVehiculos();
      this.getVehiculos();
      this.getEmpleados();
      //this.getCuestionario();
      this.getTipoDocumentos();
      this.getTiposCombustible();
      this.getFolioHojaInspeccion();
    }
  },
  beforeMount() {
    if (authConfig.EmpresaId > 0) {
      setTimeout(() => {
        this.searchInspeccion();
      }, 500);
      this.forceRerender();
    }
  },
  provide: {
    lineargauge: [Annotations]
  },
  methods: {
    changeOtros(tr, index) {
      if (this.Otro[index]) {
        if (this.Otros.length > 0) {
          let fgEncontrado = false;
          for (let i in this.Otros) {
            if (this.Otros[i].idRespuesta == tr.Respuestas[0].RespuestaID) {
              this.Otros[i].Respuesta = this.Otro[index];
              fgEncontrado = true;
            }
          }

          if (!fgEncontrado) {
            this.Otros.push({
              idRespuesta: tr.Respuestas[0].RespuestaID,
              Respuesta: this.Otro[index],
            });
          }
          //console.log(this.Otros);
        } else {
          this.Otros.push({
            idRespuesta: tr.Respuestas[0].RespuestaID,
            Respuesta: this.Otro[index],
          });
        }
      } else {
        if (this.Otros.length > 0) {
          let fgEncontrado = false;
          let indice = 0;
          for (let i in this.Otros) {
            if (this.Otros[i].idRespuesta == tr.Respuestas[0].RespuestaID) {
              this.Otros[i].Respuesta = this.Otro[index];
              indice = i;
              fgEncontrado = true;
            }
          }

          if (fgEncontrado) {
            this.Otros = this.Otros.splice(indice, 1);
          }
          //console.log(this.Otros);
        }
      }
    },
    gaugeLoad(){
      //console.log(this.$refs.lineargauge);
      
      if(this.fgMedidorCombustibleSalida.fgVisible){
        this.$refs.lineargauge.ej2Instances.annotations = [                        
            {
                content: '<div id="lowText"><b><span style="font-size:15px;color:#248622;">F</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 100,
                x: 15,
                //y: 20
            },            
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">3/4</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 75,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">1/2</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 50,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">1/4</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 25,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="highText"><b><span style="font-size:15px;color:#b42f2f;">E</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 0,
                x: 15,                
            }
        ];
        //this.count = 0;
        this.$refs.lineargauge.ej2Instances.refresh();
      }    
      
      if(this.fgMedidorCombustibleLlegada.fgVisible){
        this.$refs.lineargaugeLL.ej2Instances.annotations = [                        
            {
                content: '<div id="lowText"><b><span style="font-size:15px;color:#248622;">F</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 100,
                x: 15,
                //y: 20
            },            
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">3/4</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 75,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">1/2</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 50,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="lowText"><b><span style="font-size:15px;">1/4</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 25,
                x: 15,
                //y: 20
            },    
            {
                content: '<div id="highText"><b><span style="font-size:15px;color:#b42f2f;">E</span></b></div>',
                axisIndex: 0, zIndex: '1',
                axisValue: 0,
                x: 15,                
            }
        ];
        //this.count = 0;
        this.$refs.lineargaugeLL.ej2Instances.refresh();
      }
         //console.log(args);
      //   console.log(this.$refs.lineargauge);
    },
    PointerRender(args) {
      //console.log(args);
      //console.log(args.pointer)
      //console.log(args.pointer.value)
      this.idCombustible.id = Math.round(args.value);
    },
    PointerRenderLlegada(args) {
      //console.log(args);
      this.idCombustibleLlegada.id = Math.round(args.currentValue);
    },
    undo(index, tipo) {
      
      if (tipo == 1) {
        let indexSelected = 0;
        $.each(this.$refs.signaturePad_salida, (c, ref) =>{
          //console.log(ref);
          if(ref.$attrs.id == "signature"+index){
            indexSelected = c;
          }
        });
        this.$refs.signaturePad_salida[indexSelected].undoSignature();
        const { isEmpty, data } = this.$refs.signaturePad_salida[
          indexSelected
        ].saveSignature();

        if (!isEmpty) {
          this.ArrayFirmas[index].lsFirmas[0].Firma = data;
        } else {
          this.ArrayFirmas[index].lsFirmas[0].Firma = null;
        }
        //this.loadSignatures();
      } else {
        let indexSelected = 0;
        $.each(this.$refs.signaturePad, (c, ref) =>{
          //console.log(ref);
          if(ref.$attrs.id == "signature"+index){
            indexSelected = c;
          }
        });

        //console.log(this.$el)
        this.$refs.signaturePad[indexSelected].undoSignature();
        const { isEmpty, data } = this.$refs.signaturePad[
          indexSelected
        ].saveSignature();
        let indexLL = (this.ArrayFirmas[index].Origen == null) ? 1 : 0;      
        if (!isEmpty) {
          this.ArrayFirmas[index].lsFirmas[indexLL].Firma = data;
        } else {
          this.ArrayFirmas[index].lsFirmas[indexLL].Firma = null;
        }
        //this.loadSignatures();
      }
    },
    Clear(index, tipo) {
      if (tipo == 1) {
        let indexSelected = 0;
        $.each(this.$refs.signaturePad_salida, (c, ref) =>{
          //console.log(ref);
          if(ref.$attrs.id == "signature"+index){
            indexSelected = c;
          }
        });
        this.$refs.signaturePad_salida[indexSelected].clearSignature();
        this.ArrayFirmas[index].lsFirmas[0].Firma = null;
      } else {
        let indexSelected = 0;
        $.each(this.$refs.signaturePad, (c, ref) =>{
          //console.log(ref);
          if(ref.$attrs.id == "signature"+index){
            indexSelected = c;
          }
        });
        let indexLL = (this.ArrayFirmas[index].Origen == null || this.ArrayFirmas[index].Origen == 'LLEGADA') ? 1 : 0;
        this.$refs.signaturePad[indexSelected].clearSignature();
        this.ArrayFirmas[index].lsFirmas[indexLL].Firma = null;
      }
    },
    forceRerender() {
      this.renderComponents = false;

      this.$nextTick(() => {
        this.renderComponents = true;
      });
    },
    ActivePopup() {
      this.getCamposHojaInspeccion();
      this.getCamposFirmas();
      this.titlePopup =
        parseInt(this.HojaIID) > 0
          ? "Editar hoja de inspección vehícular"
          : "Hoja de inspección vehícular de salida";

          //asignamos el modo
          this.HojaInspeccionModoEdicion=parseInt(this.HojaIID) > 0?true:false;
      this.popupActive = true;

      // $.each($(".vs-checkbox--input"), (index, check) => {
      //   console.log(check);
      //   if (this.HojaIID == 0) {
      //     $("div.tb_SALIDA .vs-checkbox--input").click();
      //   }
      // });

      this.forceRerenderForm();
    },
    filterInputDecimals(tipo) {
      switch (parseInt(tipo)) {
        case 1:
          //this.Kilometraje = this.Kilometraje.replace(/[0-9]+(\.[0-9][0-9]?)?/g, "")
          break;
        case 2:
          //this.KilometrajeFinal = this.KilometrajeFinal.replace(/[^0-9]+/g, "")
          break;
        case 3:
          //this.litrosCargados = this.litrosCargados.replace(/[^0-9]+/g, "")
          break;
      }
      tipo == 3 ? this.Kilometraje.replace(/[^0-9]+/g, "") : this.Kilometraje;
    },
    //handleSelected(tr) {
      
      //console.log(this.selected);
      // this.$vs.notify({
      //   title: `Selected ${tr.username}`,
      //   text: `Email: ${tr.email}`
      // });
    //},
    marketPoint() {
      const vm = this;
      const noPoints = vm.pointsMarker.length;
      if (vm.namePoint == null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "Ingrese el nombre del detalle encontrado",
        });
        return;
      }

      if (vm.tipoAveriaID == null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "seleccione el tipo de detalle",
        });
        return;
      }

      if (vm.px === 0 || vm.py === 0) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "seleccione una ubicación válida",
        });
        return;
      }
      // for (let i = 0; i < vm.pointsMarker.length; i++) {
      //   if (vm.pointsMarker[i].Detalle === vm.namePoint) {
      //     this.$vs.notify({
      //       time: 5000,
      //       color: "danger",
      //       title: "Alerta",
      //       text: "Ya existe un punto con el nombre: " + vm.namePoint,
      //     });
      //     return; //
      //   }
      // }
      // var tipoID = vm.tipoAverias.filter(item => {
      //   if (item.id === vm.tipoAveriaID.id) {
      //     return item.id;
      //   }
      // });
      //console.log(vm.arregloImgsCarro[vm.indiceCurrent]);

      vm.pointsMarker.push({
        AveriaID: 0,
        Numero: noPoints + 1,
        Detalle: vm.namePoint,
        EjeX: vm.px,
        EjeY: vm.py,
        ImagenID: vm.arregloImgsCarro[vm.indiceCurrent].id,
        TipoAveria: vm.tipoAveriaID.id,
        Nombre: vm.arregloImgsCarro[vm.indiceCurrent].titulo,
        AveriaName: vm.tipoAveriaID.label,
        FechaRegistro:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes(),
        Origen: vm.fgLlegada ? "LLEGADA" : "SALIDA",
      });
      vm.namePoint = "";
      vm.paintPoints();
      vm.tipoAveriaID = [];
      vm.px = 0;
      vm.py = 0;
    },
    deletePoint(index) {
      //console.log(index);
      //return;

      let vm = this;
      vm.pointsMarker.splice(index, 1);
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    antImg() {
      const vm = this;
      vm.svgTest = null;
      const indice = vm.indiceCurrent - 1;
      if (indice <= 0) {
        vm.imgCarro = vm.arregloImgsCarro[0].img;
        vm.indiceImg = vm.arregloImgsCarro[0].id;
        vm.indiceCurrent = 0;
        vm.tituloIMG = vm.arregloImgsCarro[0].titulo;
      } else {
        vm.imgCarro = vm.arregloImgsCarro[indice].img;
        vm.indiceImg = vm.arregloImgsCarro[indice].id;
        vm.indiceCurrent = vm.indiceCurrent - 1;
        vm.tituloIMG = vm.arregloImgsCarro[indice].titulo;
      }
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    sigImg() {
      const vm = this;
      vm.svgTest = null;
      const indice = vm.indiceCurrent + 1;
      const noImgs = vm.arregloImgsCarro.length - 1;
      if (indice >= noImgs) {
        vm.imgCarro = vm.arregloImgsCarro[noImgs].img;
        vm.indiceImg = vm.arregloImgsCarro[noImgs].id;
        vm.indiceCurrent = noImgs;
        vm.tituloIMG = vm.arregloImgsCarro[noImgs].titulo;
      } else {
        vm.imgCarro = vm.arregloImgsCarro[indice].img;
        vm.indiceImg = vm.arregloImgsCarro[noImgs].id;
        vm.indiceCurrent = vm.indiceCurrent + 1;
        vm.tituloIMG = vm.arregloImgsCarro[indice].titulo;
      }
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    getCordenadas(event) {
      const vm = this;
      const i = document.querySelector("#img-element"); //$("#img-element");
      vm.image_width = i.offsetWidth;
      vm.image_height = i.offsetHeight;
      window.ev = event;
      vm.px = event.offsetX + 11;
      vm.py = event.offsetY + 23;
      //console.log(event.offsetX + " _ " + event.offsetY);
      vm.svgTest = null;
      const newSvg = `<svg width="100%" id="punto-defectiva" height="100%" style="position: absolute; left: 0px; top: 0px;pointer-events: none; z-index: 1000">
                         <g>
                           <circle cx="${vm.px}" cy="${vm.py}" z="5" r="10" stroke="#f0ab00" stroke-width="4" fill="#f0ab00" />
                           </circle>
                           <text x="${vm.px}" y="${vm.py}" text-anchor="middle" color="white" alignment-baseline="central" fill="black">
                               Point
                            </text>
                         </g>
                      </svg>`;

      vm.svgTest = newSvg;
      /* if (TweenMax.isTweening(vm.$refs.incomingDef)) {
        TweenMax.killTweensOf(vm.$refs.incomingDef)
        vm.$refs.incomingDef.style.opacity = '1'
      }
      TweenMax.to(vm.$refs.incomingDef, 0.5, { opacity: 0.3, repeat: -1, yoyo: true }) */
    },
    paintPoints() {
      const vm = this;
      let colorPoint = "";
      //console.log(this.pointsMarker);
      for (let i = 0; i < vm.pointsMarker.length; i++) {
        var tipoAveria = vm.pointsMarker[i].AveriaName;
        if (tipoAveria == "RAYON") {
          colorPoint = "#baf1a1";
        } else if (tipoAveria == "ABOLLADURA") {
          colorPoint = "#ea728c";
        } else {
          colorPoint = "#459CD2";
        }
        vm.indiceImg = this.arregloImgsCarro.filter((obj) => {
          if (obj.id == vm.pointsMarker[i].ImagenID) {
            return obj;
          }
        })[0].id;

        if (
          vm.pointsMarker[i].ImagenID ===
          this.arregloImgsCarro[vm.indiceCurrent].id
        ) {
          //
          const newSvg = `<svg width="100%" id="punto-defectiva" height="100%" style="position: absolute; left: 0px; top: 0px;pointer-events: none; z-index: 1000">
                         <g>
                           <circle cx="${vm.pointsMarker[i].EjeX}" cy="${vm.pointsMarker[i].EjeY}" z="5" r="10" stroke="${colorPoint}" stroke-width="4" fill="${colorPoint}" />
                           </circle>
                           <text x="${vm.pointsMarker[i].EjeX}" y="${vm.pointsMarker[i].EjeY}" text-anchor="middle" color="white" alignment-baseline="central" fill="black">
                               ${vm.pointsMarker[i].Numero}
                            </text>
                         </g>
                      </svg>`;

          switch (vm.pointsMarker[i].Numero) {
            case 1:
              vm.pointOne = newSvg;
              break;
            case 2:
              vm.pointTwo = newSvg;
              break;
            case 3:
              vm.pointThre = newSvg;
              break;
            case 4:
              vm.pointFor = newSvg;
              break;
            case 5:
              vm.pointFive = newSvg;
              break;
            case 6:
              vm.pointSix = newSvg;
              break;
            case 7:
              vm.pointSeven = newSvg;
              break;
            case 8:
              vm.pointEigth = newSvg;
              break;
            case 9:
              vm.pointNine = newSvg;
              break;
            case 10:
              vm.pointTen = newSvg;
              break;
            case 11:
              vm.pointEleven = newSvg;
              break;
            case 12:
              vm.pointTwelve = newSvg;
              break;
            case 13:
              vm.pointThirteen = newSvg;
              break;
            case 14:
              vm.pointFourTeen = newSvg;
              break;
            case 15:
              vm.pointFifTeen = newSvg;
              break;
            case 16:
              vm.pointSixTeen = newSvg;
              break;
            case 17:
              vm.pointSevenTeen = newSvg;
              break;
            case 18:
              vm.pointEigthTeen = newSvg;
              break;
            case 19:
              vm.pointNineTeen = newSvg;
              break;
            case 20:
              vm.pointTwenty = newSvg;
              break;
          }
        }
      }
    },
    cancelSearchInspeccion(){
      this.fcalendarEdit= new Date();
      this.fcalendarFinal= new Date().setDate(new Date().getDate() + 1);
      this.FiltroAveria = "";
      this.vIncidencia = "";
      this.vBusquedaVehiculo = "";
      this.vBusquedaAveria = "";
      this.searchInspeccion();

    },
    searchInspeccion() {
      const vm = this;
      const parametros = {};

      //vm.Detalle_Tabla = []
      /* if (vm.noInspeccion === null || vm.noInspeccion === '' || vm.noInspeccion === 0 || isNaN(vm.noInspeccion) === true) {
        vm.msjException = true
        vm.msjAlerta = 'Ingrese un número de inspección válido'
        return false
      } */
      if (vm.fcalendarEdit === null || vm.fcalendarFinal === null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "Ingrese un rango de fechas valido",
        });

        return false;
      }
      parametros.feInicio =
        new Date(vm.fcalendarEdit).getFullYear() +
        "-" +
        (new Date(vm.fcalendarEdit).getMonth() + 1) +
        "-" +
        new Date(vm.fcalendarEdit).getDate();
      parametros.feFin =
        new Date(vm.fcalendarFinal).getFullYear() +
        "-" +
        (new Date(vm.fcalendarFinal).getMonth() + 1) +
        "-" +
        new Date(vm.fcalendarFinal).getDate();
      parametros.EmpresaID = authConfig.EmpresaId; //authConfig.EmpresaId;
      parametros.ID = 1;
      parametros.desDetalle = vm.vBusquedaAveria;
      parametros.desVehiculo = vm.vBusquedaVehiculo;
      parametros.tipoAveriaID = vm.FiltroAveria ? vm.FiltroAveria.id : 0;
      parametros.vIncidencia = vm.vIncidencia.id;
      //      vm.overlay = true
      //vm.Api + "/api/HojaInspeccion/GetByRango"
      //
      $.ajax({
        url: vm.WS + "/Checklist/GetByRango",
        type: "POST",
        dataType: "Json",
        async: false,
        data: parametros,
        success: (res) => {
          // this.datos.gridOptions = {};
          // this.datos.columnDefs = [];
          // this.datos.defaultColDef = {
          //   editable: false
          // };
          // this.datos.gridApi = null;
          this.datos = res.Data;
          //console.log(this.datos);
          //     //this.forceRerender();
          // }
        },
      });

      this.forceRerender();
      this.validateColumns();
    },
    validateColumns() {
      let vm = this;
      this.datos.columnDefs = [];
      if (this.datos.json.length > 0) {
        this.datos.columnDefs = [
          { headerName: "FOLIO", field: "NO", width: 100, sortable: true, },
        ];
        this.datos.columnDefs.push({
          headerName: "ESTATUS",
          field: "ESTATUS",
          sortable: true,
          width: 150,
        });
        if (this.fgTipoDocumento.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "TIPO",
            field: "TIPO",
            sortable: true,
            width: 250,
          });
        }

        if (this.fgFechaSalida.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "FECHA SALIDA",
            field: "FECHA",
            sortable: true,
            width: 200,
          });
        }

        if (this.fgFechaLlegada.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "FECHA LLEGADA",
            field: "FECHALLEGADA",
            sortable: true,
            width: 200,
          });
        }

        if (this.fgCliente.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "CLIENTE",
            field: "CLIENTE",
            sortable: true,
            width: 350,
          });
        }

        if (this.fgContrato.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "CONTRATO",
            field: "CONTRATO",
            sortable: true,
            width: 200,
          });
        }

        if (this.fgVehiculo.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "VEHÍCULO/MANTENIBLE",
            field: "VEHICULO",
            sortable: true,
            width: 300,
          });
        }

        if (this.fgTipoVehiculo.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "TIPO DE VEHÍCULO/MANTENIBLE",
            field: "TIPOVEHICULO",
            sortable: true,
            width: 350,
          });
        }

        // if(this.fgTipoChasis.fgVisible){
        //   this.datos.columnDefs.push({
        //     headerName: "TIPO DE CHASIS",
        //     width: 350,
        //     cellRenderer: function boton(params) {
        //       return options3.filter(item => {
        //         if(item.id == params.data.)
        //       });
        //     }
        //   })
        // }

        if (this.fgFactura.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "FACTURA",
            field: "FACTURA",
            sortable: true,
            width: 200,
          });
        }
        if (this.fgEstacion.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "ESTACIÓN",
            field: "ESTACION",
            sortable: true,
            width: 300,
          });
        }

        if (this.fgInspector.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "INSPECTOR",
            field: "INSPECTOR",
            sortable: true,
            width: 350,
          });
        }
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 90,
          pinned: "right",
          cellRenderer: function boton(params) {
            vm.PerfilID = vm.PerfilID === 2 ? 1 : vm.PerfilID;
            //console.log(vm.PerfilID);
            return (
              `<i class="feather icon-info" @click="this.editInspeccion(` +
              params.data.NO +
              `, 0)" style="font-size: 24px;cursor: pointer;" title="CONSULTAR HOJA DE INSPECCIÓN"></i>`
            );
          },
          onCellClicked: (params) => {
            vm.PerfilID = vm.PerfilID === 2 ? 1 : vm.PerfilID;
            // console.log(vm.PerfilID);
            vm.fgConsultar = true;
            vm.fgLlegada = params.data.ESTATUS == "ABIERTO" ? false : true;
            this.editInspeccion(params.data.ID);
            vm.titlePopup =
              "Hoja de inspección vehicular No. " +
              params.data.NO +
              " (" +
              (vm.fgLlegada ? "llegada" : "salida") +
              ")";
            if (params.data.ESTATUS == "ABIERTO") {
              vm.Activo = 1;
              vm.HojaIID = 0;
            }
          },
        });
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 90,
          pinned: "right",
          cellRenderer: function boton(params) {
            return params.data.ESTATUS == "ABIERTO"
              ? `<i class="feather icon-plus editar" @click="this.editInspeccion(` +
                  params.data.NO +
                  `)" style="font-size: 24px;cursor: pointer" title="REGISTRAR LLEGADA"></i>`
              : "";
          },
          onCellClicked: (params) => {
            if (params.data.ESTATUS == "ABIERTO") {
              vm.fgLlegada = true;
              vm.editInspeccion(params.data.ID);
              vm.titlePopup =
                params.data.ESTATUS == "ABIERTO"
                  ? "Hoja de inspección vehicular No. " +
                    params.data.NO +
                    " (llegada)."
                  : "Hoja de inspección vehicular No. " + params.data.NO;
            }
          },
        });
        if (authConfig.PerfilEmpleado.PerfilID === 2) {
          this.datos.columnDefs.push({
            headerName: "",
            filter: false,
            width: 90,
            pinned: "right",
            cellRenderer: function boton(params) {
              return (
                `<i class="feather icon-edit-2 ` +
                ` editar" @click="this.editInspeccion(` +
                params.data.ID +
                `)" style="font-size: 24px;cursor: pointer" title="EDITAR"></i>` +
                '<i class="feather icon-edit-2 text-danger editar" style="font-size: 24px;cursor:not-allowed"></i>'
              );
            },
            onCellClicked: (params) => {
              if (authConfig.PerfilEmpleado.PerfilID === 2) {
                //vm.fgConsultar = false;
                if (params.data.ESTATUS == "ABIERTO") {
                  vm.fgLlegada = false;
                } else {
                  vm.fgLlegada = true;
                }
                vm.editInspeccion(params.data.ID);
                vm.titlePopup =
                  "Editar hoja de inspección vehicular No. " +
                  params.data.NO +
                  " (" +
                  (vm.fgLlegada ? "llegada" : "salida") +
                  ")";
              }
            },
          });
        }
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 90,
          pinned: "right",
          cellRenderer: function boton() {
            return `<i class="feather icon-printer imprimir" style="font-size: 24px;cursor: pointer" title="IMPRIMIR"></i>`;
          },
          onCellClicked: (params) => {
            let tipo = params.data.ESTATUS == "ABIERTO" ? 1 : -1;
            this.imprimirInspeccion(params.data.ID, tipo);
          },
        });
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 90,
          pinned: "right",
          cellRenderer: function boton() {
            return `<i class="feather icon-file incidencia" style="font-size: 24px;cursor: pointer" title="INCIDENCIA"></i>`;
          },
          onCellClicked: (params) => {
            //console.log(params);
            //let tipo = params.data.ESTATUS == "ABIERTO" ? 1 : -1;
            this.GenerarIncidencia(params.data.ID, params.data.NO, params.data.VEHICULO);
          },
        });
        // {
        //   headerName: "",
        //   filter: false,
        //   width: 100,
        //   pinned: "right",
        //   cellRenderer: function boton(params) {
        //     return `<i class="feather icon-printer imprimir" style="font-size: 24px;cursor: pointer" title="Imprimir"></i>`;
        //   },
        //   onCellClicked: function(params) {
        //     console.log(params.data);
        //   }
        // }
      }
    },
    editInspeccion(x) {
      
      const vm = this;
      vm.HojaInspeccionModoEdicion=true;
      vm.selected = [];
      vm.pointsMarker = [];
      vm.banderaEdit = 1;
      vm.overlay = true;
      $.ajax({
        url: this.WS + "/Checklist/getHojaInspeccionById",
        type: "POST",
        dataType: "Json",
        data: { ID: x, type: (this.fgLlegada ? "LLEGADA" : "SALIDA") },
        async: false,
        success: (res) => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text:
                "Ocurrió un error inesperado, favor de intentarlo de nuevo.",
            });

            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje,
            });

            return;
          }
          this.HojaIID = x;
          //console.log(res.Data);
          //console.log(this.TiposVehiculos);
          this.idCliente = vm.fgCliente.fgVisible
            ? vm.options1.filter((item) => {
                if (item.id == res.Data.ClienteID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };         
          // this.idAyudante = vm.fgAyudante.fgVisible
          //   ? vm.options6.filter((item) => {
          //       if (item.id == res.Data.AyudanteID) {
          //         return item;
          //       }
          //     })[0]
          //   : { id: 0, label: "" };
          this.Nombre = vm.fgNombreCliente.fgVisible
            ? res.Data.NombreCliente
            : "";
          this.idTipoDocumento = vm.fgTipoDocumento.fgVisible
            ? vm.options2.filter((item) => {
                if (item.id == res.Data.TipoInspeccion) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idTipoChasis = vm.fgTipoChasis.fgVisible
            ? vm.options3.filter((item) => {
                if (item.id == res.Data.TipoChasisID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Contrato = vm.fgContrato.fgVisible ? res.Data.Contrato : "";
          this.Factura = vm.fgFactura.fgVisible ? res.Data.Factura : "";
          this.idTipoVehiculo = vm.fgTipoVehiculo.fgVisible
            ? this.TiposVehiculos.filter((item) => {
                if (item.id == res.Data.TipoVehiculoID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          setTimeout(() => {
            this.idVehiculo = vm.fgVehiculo.fgVisible
              ? vm.options4.filter((item) => {
                  if (item.id == res.Data.VehiculoID) {
                    return item;
                  }
                })[0]
              : { id: 0, label: "" };
          }, 500);
          //console.log(vm.fgOperador.fgVisible);
          setTimeout(() => {
            this.idOperador = vm.fgOperador.fgVisible
              ? vm.optionsO.filter((item) => {
                  if (item.id == res.Data.OperadorID) {
                    return item;
                  }
                })[0]
              : { id: 0, label: "" };
          }, 500);

          setTimeout(() => {
             if (vm.fgAyudante.fgVisible) {
              //console.log(res.Data.ayudantes);
              //console.log(vm.options6);
              if (res.Data.ayudantes.length > 0) {
                for (let op in vm.options6) {
                  for (let ayu in res.Data.ayudantes) {
                    if (
                      vm.options6[op].id == res.Data.ayudantes[ayu].AyudanteID
                    ) {
                      if (this.idAyudante.length > 0) {
                        let fgEncontrado = false;
                        for (let ida in this.idAyudante) {
                          if (
                            this.idAyudante[ida].id ==
                            res.Data.ayudantes[ayu].AyudanteID
                          ) {
                            fgEncontrado = true;
                          }
                        }

                        if (!fgEncontrado) {
                          this.idAyudante.push(vm.options6[op]);
                        }
                      } else {
                        this.idAyudante.push(vm.options6[op]);
                      }
                      //console.log(vm.options6[op]);
                    }
                  }
                }
                //console.log(this.idAyudante);
              } else {
                this.idAyudante = [];
              }
            }
          }, 500);
          this.idEstacion = vm.fgEstacion.fgVisible
            ? vm.options5.filter((item) => {
                if (item.label == res.Data.Estacion) {
                  return item;
                }

                if (item.id === res.Data.Estacion) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idEmpleado = vm.fgInspector.fgVisible
            ? vm.options6.filter((item) => {
                if (item.id == res.Data.InspectorID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          //vm.getLlantasVehiculo()

          //this.fgVisibleLlanta = false;
          this.Comentarios = vm.fgDetalleVehiculo.fgVisible
            ? res.Data.DetalleVehiculo
            : "Empty";
          this.idCombustible = vm.fgCombustibleInicial.fgVisible
            ? vm.options7.filter((item) => {
                if (item.id === res.Data.Combustible) {
                  return item;
                }
              })[0]
            : vm.fgMedidorCombustibleSalida.fgVisible
            ? { id: res.Data.Combustible, label: "" }
            : { id: 0, label: "" };
          this.idTipoCombustible = vm.fgTipoCombustible.fgVisible
            ? vm.options8.filter((item) => {
                if (item.id === res.Data.TipoCombustibleID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Kilometraje = vm.fgKilometrajeSalida.fgVisible
            ? parseFloat(res.Data.Kilometraje).FormatMiles()
            : 0;
          this.KilometrajeFinal = vm.fgKilometrajeLlegada.fgVisible
            ? parseFloat(res.Data.KilometrajeLlegada).FormatMiles()
            : 0;
          this.KilometrajeEdicion =
            res.Data.KilometrajeLlegada != null &&
            parseFloat(res.Data.KilometrajeLlegada) > 0
              ? res.Data.KilometrajeLlegada
              : res.Data.Kilometraje;
          this.idCombustibleLlegada = vm.fgCombustibleFinal.fgVisible
            ? vm.options7.filter((item) => {
                if (item.id === res.Data.CombustibleLlegada) {
                  return item;
                }
              })[0]
            : vm.fgMedidorCombustibleLlegada.fgVisible
            ? {
                id: !res.Data.CombustibleLlegada
                  ? 0
                  : res.Data.CombustibleLlegada,
                label: "",
              }
            : { id: 0, label: "" };
          this.litrosCargados = vm.fgLitrosCargados.fgVisible
            ? parseFloat(res.Data.LitrosCargados).FormatMiles()
            : 0;
          this.fSalida = vm.fgFechaSalida.fgVisible
            ? new Date(res.Data.FechaSalida)
            : new Date();
          this.time = vm.fgHoraSalida.fgVisible
            ? res.Data.Hours
            : new Date().getHours() + ":" + new Date().getMinutes();

          if (this.idTipoVehiculo != null) {
            if (this.idTipoVehiculo.Fotos.length > 0) {
              for (var i in this.idTipoVehiculo.Fotos) {
                if (this.idTipoVehiculo.Fotos[i].Orden < 5) {
                  this.arregloImgsCarro.push({
                    img: this.idTipoVehiculo.Fotos[i].ImagenUrl,
                    indice: this.idTipoVehiculo.Fotos[i].Orden,
                    id: this.idTipoVehiculo.Fotos[i].TipoVehiculoFotoID,
                    titulo:
                      this.idTipoVehiculo.Fotos[i].Orden == 1
                        ? "FRONTAL"
                        : this.idTipoVehiculo.Fotos[i].Orden == 2
                        ? "TRASERA"
                        : this.idTipoVehiculo.Fotos[i].Orden == 3
                        ? "LATERAL DER"
                        : "LATERAL IZQ",
                    TipoVehiculoID: this.idTipoVehiculo.Fotos[i].TipoVehiculoID,
                  });
                }
              }

              this.imgCarro = this.arregloImgsCarro[0].img;
            } else {
              // this.$vs.notify({
              //   color: "danger",
              //   time: 5000,
              //   title: "Alerta",
              //   text:
              //     "El tipo de vehículo " +
              //     this.idTipoVehiculo.label +
              //     " no tiene imágenes de detalles del vehículo asignados."
              // });
            }
          }

          const infoAverias =
            this.arregloImgsCarro.length > 0 ? res.Data.Averias : [];
          if (infoAverias.length > 0) {
            for (let i = 0; i < infoAverias.length; i++) {
              const tipoAveriaName = vm.tipoAverias.filter((item) => {
                if (item.id === infoAverias[i].TipoAveria) {
                  return item;
                }
              });
              this.pointsMarker.push({
                AveriaID: infoAverias[i].AveriaID,
                Numero: infoAverias[i].Numero,
                Detalle: infoAverias[i].Detalle,
                EjeX: infoAverias[i].EjeX,
                EjeY: infoAverias[i].EjeY,
                ImagenID: infoAverias[i].ImagenID,
                TipoAveria: tipoAveriaName[0].id,
                Nombre: this.arregloImgsCarro.filter((item) => {
                  if (item.id === infoAverias[i].ImagenID) {
                    return item;
                  }
                })[0].titulo,
                AveriaName: tipoAveriaName[0].label,
                FechaRegistro: infoAverias[i].FechaRegistro,
                Origen: infoAverias[i].Origen,
              });
            }
            this.paintPoints();
          } else {
            this.pointsMarker = [];
          }

          //console.log(res.Data.Cuestionario);
          setTimeout(() => {
          if (res.Data.Cuestionario.length > 0) {
            for (let i = 0; i < res.Data.Cuestionario.length; i++) {
              for (
                let x = 0;
                x < vm.CuestionarioEmpresa.Secciones.length;
                x++
              ) {
                for (
                  let y = 0;
                  y < vm.CuestionarioEmpresa.Secciones[x].Preguntas.length;
                  y++
                ) {
                  if (
                    vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                      .PreguntaID === res.Data.Cuestionario[i].PreguntaID
                  ) {
                    //
                    vm.selected.push(
                      vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                    );

                    if (
                      vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                        .TipoPreguntaID == 2
                    ) {
                      vm.Otro[x] = res.Data.Cuestionario[i].Respuesta;

                      vm.Otros.push({
                        idRespuesta:
                          vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                            .Respuestas[0].RespuestaID,
                        Respuesta: this.Otro[x],
                      });
                    }
                  }
                }
              }
            }
          }
          },500);

          this.Activo = res.Data.Activo;          
          vm.ActivePopup();

          if (this.ArrayFirmas.length > 0) {
            if (res.Data.Firmas != null && res.Data.Firmas.length > 0) {
              this.ArrayFirmas = res.Data.Firmas;
              //console.log(res.Data.Firmas);
              //console.log(this.ArrayFirmas);
              //this.options.onBegin = () => {};
              //console.log(this.ArrayFirmas);
              for (var index in this.ArrayFirmas) {
                //this.$nextTick(() => {
                  if(this.ArrayFirmas[index].Origen == "SALIDA"){
                    for(let ind in this.ArrayFirmas[index].lsFirmas){
                      this.ArrayFirmas[index].lsFirmas[ind].Nombre = this.ArrayFirmas[index].lsFirmas[ind].NombreObj;               
                    }       
                  }                                     
                //});
              }
            }
          }
        },
      });
    },
    imprimirInspeccion(x, tipo) {
      let urlReporte = this.fgChecklistW.fgVisible
        ? "/Checklist/ImprimirFormatoKanan?json="
        : "/Checklist/ImprimirInspeccion?json=";
      if (tipo == -1) {
        let parameters = { idHoja: x, Tipo: 0 };
        window.location.href =
          this.WS + urlReporte + JSON.stringify(parameters);
      } else {
        let parameters = { idHoja: x, Tipo: 1 };
        window.location.href =
          this.WS + urlReporte + JSON.stringify(parameters);
      }
    },
    GenerarIncidencia(x, Folio, Vehiculo){
      this.$vs.loading();
      this.objIncidencia = {
        id: x,
        Folio: Folio,
        Vehiculo: Vehiculo
      }
      this.popupActiveIncidencia = true;
      this.titlePopupIncidencia = "Incidencia para la Hoja de Inspección: "+Folio;
      this.dataForm.HojaInspeccionID = x;
      this.dataForm.Vehiculo = Vehiculo;

      //COMENTARIO

      $.ajax({
        url: this.Api + "/api/IncidenciaVehiculo/GetFolioIncidenciaByEmpresaId/"+ authConfig.EmpresaId,
        type: "GET",
        dataType: "Json",
        async: false,
        success: (res) => {
          // console.log(res);
          if(res.length > 0){
            this.dataForm.Folio = res[0].Folio;
            this.dataForm.Anio = res[0].AnioFolio;
          }
        }
      })

      $.ajax({
        url: this.WS + "/Checklist/getAveriasNoAtendidasByVehiculo",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { ID: x, tipoAveriaID: 1 },
        success: (res) => {//vBusquedaAveria,FiltroAveria
          if (res.Data.length > 0) {
            this.dataForm.Incidencias = [];
            const infoAverias = res.Data;
            if (infoAverias.length > 0) {
              for (let i = 0; i < infoAverias.length; i++) {
                this.dataForm.lsAllIncidencias.push(infoAverias[i]);

                if(this.FiltroAveria){
                  if (infoAverias[i].TipoAveria == this.FiltroAveria.id) {
                    this.dataForm.Incidencias.push(infoAverias[i]);
                    continue;
                  }
                }                
                // console.log(this.vBusquedaAveria);
                if(this.vBusquedaAveria){
                  var term = this.vBusquedaAveria; // search term (regex pattern)
                  var search = new RegExp(term , 'i'); // prepare a regex object
                  
                  if (search.test(infoAverias[i].Detalle)) {
                    this.dataForm.Incidencias.push(infoAverias[i]);
                    continue;
                  }                
                }                
              }

              
              
            } else {
              this.dataForm.lsAllIncidencias = [];
            }
          } else{
            this.dataForm.lsAllIncidencias = [];
          }
        },error(){
          this.dataForm.lsAllIncidencias = [];
        }
      });

      $.ajax({
        url: this.WS + "/Checklist/getAveriasIncidenciaNoAtendidasByVehiculo",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { ID: x },
        success: (res) => {//vBusquedaAveria,FiltroAveria
          if (res.Data.length > 0) {
            const infoAveriasI = res.Data;
            if (infoAveriasI.length > 0) {
              for (let i = 0; i < infoAveriasI.length; i++) {
                this.dataForm.lsAllIncidenciasGenerada.push(infoAveriasI[i]);                            
              }              
            } else {
              this.dataForm.lsAllIncidenciasGenerada = [];
            }
          } else{
            this.dataForm.lsAllIncidenciasGenerada = [];
          }
        },error(){
          this.dataForm.lsAllIncidenciasGenerada = [];
        }
      });


      setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
    },
    cancelFormPopup(){
        this.popupActiveIncidencia = false;
        this.clearFormIncidencia();
    },
    clearFormIncidencia(){
      this.dataForm.Incidencias = [];
      this.dataForm.lsAllIncidencias = [];
      this.dataForm.lsAllIncidenciasGenerada = [];
      this.dataForm = this.emptyDataForm;
    },
    validateStep1Incidencia(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1-incidencia").then(result => {
          if (result) {
            if(this.dataForm.Incidencias.length > 0){
              resolve(true);
            }else{
              if(this.dataForm.lsAllIncidencias.length == 0){
                resolve(true);
              }else{
                reject("correct all values");  
                this.$vs.notify({
                  time: 5000,
                  color: "danger",
                  title: "Validación",
                  text: "Debe seleccionar al menos un detalle en la incidencia.",
                });
              }              
            }            
          } else {
            reject("correct all values");
          }
        });
      });
    } ,   
    ImprimirIncidencia(id){
      window.location.href = this.WS + "/Checklist/ImprimirIncidencia/?id="+id;
    },
    acceptDelete(){
      this.$vs.loading();      
      this.active2 = false; 
       $.ajax({
        url: this.WS + "/Checklist/EliminarIncidencia",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { ID: this.objIncidencia.Incidencia },
        success: (response) => {//vBusquedaAveria,FiltroAveria
          //console.log(res);
          if(response.Estatus == 1){
            this.$vs.notify({
              time: 5000,
              color: "success",
              fixed: true,
              title: "Operación exitosa",
              text: response.Mensaje                
            });  
            
            this.GenerarIncidencia(this.objIncidencia.id,this.objIncidencia.Folio,this.objIncidencia.Vehiculo);
            //this.objIncidencia = {};
            // $.ajax({
            //   url: this.WS + "/Checklist/getAveriasNoAtendidasByVehiculo",
            //   type: "POST",
            //   dataType: "Json",
            //   async: false,
            //   data: { ID: response.Data, tipoAveriaID: 1 },
            //   success: (res) => {//vBusquedaAveria,FiltroAveria
            //     if (res.Data.length > 0) {
                  
            //       const infoAverias = res.Data;
            //       if (infoAverias.length > 0) {
            //         for (let i = 0; i < infoAverias.length; i++) {
            //           this.dataForm.lsAllIncidencias.push(infoAverias[i]);

            //           if(this.FiltroAveria){
            //             if (infoAverias[i].TipoAveria == this.FiltroAveria.id) {
            //               this.dataForm.Incidencias.push(infoAverias[i]);
            //               continue;
            //             }
            //           }                
            //           // console.log(this.vBusquedaAveria);
            //           if(this.vBusquedaAveria){
            //             var term = this.vBusquedaAveria; // search term (regex pattern)
            //             var search = new RegExp(term , 'i'); // prepare a regex object
                        
            //             if (search.test(infoAverias[i].Detalle)) {
            //               this.dataForm.Incidencias.push(infoAverias[i]);
            //               continue;
            //             }                
            //           }                
            //         }

                    
                    
            //       } else {
            //         this.dataForm.lsAllIncidencias = [];
            //       }
            //     } else{
            //       this.dataForm.lsAllIncidencias = [];
            //     }
            //   },error(){
            //     this.dataForm.lsAllIncidencias = [];
            //   }
            // });

            // $.ajax({
            //   url: this.WS + "/Checklist/getAveriasIncidenciaNoAtendidasByVehiculo",
            //   type: "POST",
            //   dataType: "Json",
            //   async: false,
            //   data: { ID: response.Data },
            //   success: (res) => {//vBusquedaAveria,FiltroAveria
            //     if (res.Data.length > 0) {
            //       const infoAveriasI = res.Data;
            //       if (infoAveriasI.length > 0) {
            //         for (let i = 0; i < infoAveriasI.length; i++) {
            //           this.dataForm.lsAllIncidenciasGenerada.push(infoAveriasI[i]);                            
            //         }              
            //       } else {
            //         this.dataForm.lsAllIncidenciasGenerada = [];
            //       }
            //     } else{
            //       this.dataForm.lsAllIncidenciasGenerada = [];
            //     }
            //   },error(){
            //     this.dataForm.lsAllIncidenciasGenerada = [];
            //   }
            // });

          }else{
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: response.Mensaje,
            });
          }
        },error(){
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Ocurrió un error inesperado",
            text: "No se ha podido conectar al servidor. Intente más tarde",
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
        }
      });
      
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    cancelConfirm(){
      this.active2 = false; 
      this.GenerarIncidencia(this.objIncidencia.id,this.objIncidencia.Folio,this.objIncidencia.Vehiculo);
      //this.objIncidencia = {};
    },
    EliminarIncidencia(id){
      this.objIncidencia.Incidencia = id;
      this.active2 = true;     
      this.cancelFormPopup(); 
    },
    formSubmittedIncidencia(){
      this.$vs.loading();
      this.dataForm.FechaRegistro = new Date().getFullYear() +
            "-" +
            (new Date(this.dataForm.FechaRegistro).getMonth() + 1) +            
            "-" +
            new Date(this.dataForm.FechaRegistro).getDate() +            
            " " +
            new Date(this.dataForm.FechaRegistro).getHours() + 
            ":" +
            new Date(this.dataForm.FechaRegistro).getMinutes() + 
            ":" +
            new Date(this.dataForm.FechaRegistro).getSeconds();
      $.ajax({
        url: this.WS + "/Checklist/saveIncidenciaHojaInspeccion",
        type: "POST",
        dataType: "Json",
        async: false,
        data: this.dataForm,
        success: (res) => {//vBusquedaAveria,FiltroAveria
          //console.log(res);
          if(res.Estatus == 1){
            this.$vs.notify({
              time: 5000,
              color: "success",
              fixed: true,
              title: "Operación exitosa",
              text: res.Mensaje                
            });       
             //this.ImprimirIncidencia(res.Data);
          }else{
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje,
            });
          }
        },error(){
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Ocurrió un error inesperado",
            text: "No se ha podido conectar al servidor. Intente más tarde",
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
        }
      });

      this.cancelFormPopup();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    // openConfirm(x) {
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "warning",
    //     title: `Elegir reporte`,
    //     text: "Seleccione el reporte que desea descargar.",
    //     buttonAccept: "Reporte de Llegada",
    //     buttonCancel: "Reporte General",
    //     accept: this.acceptAlert(x),
    //     cancel: this.cancelReport(x),
    //   });
    // },
    // acceptAlert(x) {
    //   var parameters = { idHoja: x, Tipo: 2 };
    //   window.location.href =
    //     this.WS +
    //     "/Checklist/ImprimirInspeccion?json=" +
    //     JSON.stringify(parameters);
    //   this.$vs.notify({
    //     color: "danger",
    //     title: "Deleted image",
    //     text: "The selected image was successfully deleted",
    //   });
    // },
    // cancelReport(x) {
    //   var parameters = { idHoja: x, Tipo: 0 };
    //   window.location.href =
    //     this.WS +
    //     "/Checklist/ImprimirInspeccion?json=" +
    //     JSON.stringify(parameters);
    //   this.$vs.notify({
    //     color: "danger",
    //     title: "Deleted image",
    //     text: "The selected image was successfully deleted",
    //   });
    // },
    handleValidation: function (isValid, tabIndex) {
      //console.log(this);
      //console.log(isValid);
      //console.log(tabIndex);      
      //console.log(this.ArrayFirmas);
      if(tabIndex == 1){
        this.gaugeLoad();
      }
      if (tabIndex == 4) {            
        this.loadSignatures();
        setTimeout(() => {
          this.loadSignatures();
        }, 1000);
      }
    },
    loadSignatures() {
      if (this.ArrayFirmas.length > 0) {
        // this.$nextTick(() => {
        //   this.$refs.signaturePadp.resizeCanvas();
        //   //ref.resizeCanvas();
        // });
        //this.$refs.signaturePad.lockSignaturePad()

        //console.log(this.ArrayFirmas);
        
        if (this.HojaIID == 0){
           for (var i in this.ArrayFirmas) {
            if (this.HojaIID == 0) {
              $.each(this.$refs.signaturePad_salida, (c, ref) => {
                this.$nextTick(() => {
                  this.$refs.signaturePad_salida[i].resizeCanvas();
                  ref.resizeCanvas();
                });
                if (this.HojaIID > 0) {
                  this.$refs.signaturePad_salida[i].saveSignature();
                  //console.log(isEmpty);
                  //console.log(data);
                  this.$refs.signaturePad_salida[i].fromDataURL(
                    this.ArrayFirmas[i].lsFirmas[0].Firma
                  );
                } else if (this.HojaIID == 0 && this.Activo == 1) {
                  this.$refs.signaturePad_salida[i].saveSignature();
                  //console.log(isEmpty);
                  //console.log(data);
                  this.$refs.signaturePad_salida[i].fromDataURL(
                    this.ArrayFirmas[i].lsFirmas[0].Firma
                  );
                }
              });
            } 
          }
        } else{
          let indexUsadoS = -1;
          $.each(this.$refs.signaturePad_salida, (c, ref) => {
            this.$nextTick(() => {
              this.$refs.signaturePad_salida[c].resizeCanvas();
              ref.resizeCanvas();
            });
            //if (this.HojaIID > 0) {
            this.$refs.signaturePad_salida[c].saveSignature();           
            for (var index in this.ArrayFirmas){
              if(this.ArrayFirmas[index].Origen == null || this.ArrayFirmas[index].Origen == "SALIDA"){
                if(indexUsadoS != index){
                  this.$refs.signaturePad_salida[c].fromDataURL(
                    this.ArrayFirmas[index].lsFirmas[0].Firma
                  ); 
                  indexUsadoS = index;
                  break;
                }              
              }
            }                       
          });          

          if (this.fgLlegada) {
            let indexUsadoLL = -1;
            $.each(this.$refs.signaturePad, (i) => {
              this.$nextTick(() => {
                this.$refs.signaturePad[i].resizeCanvas();
                //ref.resizeCanvas();
              });

              if (this.HojaIID > 0) {
                let indiceLL = (this.ArrayFirmas[i].Origen == null)? 1 : 0;
                this.$refs.signaturePad[i].saveSignature();

                for (var index in this.ArrayFirmas){
                  if(this.ArrayFirmas[index].Origen == null || this.ArrayFirmas[index].Origen == "LLEGADA"){
                    if(indexUsadoLL != index){
                      this.$refs.signaturePad[i].fromDataURL(
                        this.ArrayFirmas[index].lsFirmas[indiceLL].Firma
                      );

                      if (
                        this.ArrayFirmas[index].TipoResponsableID == 1 &&
                        !this.fgConsultar &&
                        !this.ArrayFirmas[index].lsFirmas[indiceLL].Nombre
                      ) {
                        this.ArrayFirmas[index].lsFirmas[indiceLL].Nombre = this.ArrayFirmas[
                          index
                        ].lsFirmas[0].Nombre;
                      }
                      indexUsadoLL = index;
                      break;
                    }              
                  }
                }                                 
              }
            });
          }
        }            
      }
    },
    formSubmitted() {
      if (this.fgConsultar) {
        this.popupActive = false;
      } else {
        this.saveInformacion();
      }
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            let fgValidate = true;
            if (this.fgOperador.fgVisible || this.fgAyudante.fgVisible) {
              if (this.idOperador || this.idAyudante) {                
                for (let i in this.ArrayFirmas) {
                  if (this.ArrayFirmas[i].TipoResponsableID == 1) {
                    this.ArrayFirmas[i].lsResponsables = [];
                    if(this.fgLlegada){
                      //this.ArrayFirmas[i].lsFirmas[1].Nombre = {}
                    }else{
                      //this.ArrayFirmas[i].lsFirmas[0].Nombre = {}
                    }
                    //this.ArrayFirmas[index].lsFirmas[1].Nombre
                    if (this.idOperador && this.fgOperador.fgVisible) {
                      this.ArrayFirmas[i].lsResponsables.push({
                        id: this.idOperador.label,
                        label: this.idOperador.label + " (Chofer/Operador)",
                      });

                      this.ArrayFirmas[i].lsFirmas[0].Nombre = this.ArrayFirmas[i].lsResponsables[0];
                    }

                    if (this.idAyudante && this.fgAyudante.fgVisible) {                                            
                      if(this.idAyudante.length > 1){
                        for (let y in this.idAyudante) {
                          this.ArrayFirmas[i].lsResponsables.push({
                            id: this.idAyudante[y].label,
                            label: this.idAyudante[y].label + " (Ayudante)",
                          });
                        }
                      } else if(this.idAyudante.length == 1) {
                        this.ArrayFirmas[i].lsResponsables.push({
                            id: this.idAyudante[0].label,
                            label: this.idAyudante[0].label + " (Ayudante)",
                          });
                      } else if(this.idAyudante.length == undefined){
                        this.ArrayFirmas[i].lsResponsables.push({
                            id: this.idAyudante.label,
                            label: this.idAyudante.label + " (Ayudante)",
                          });
                      }
                    }
                  }
                }
                //resolve(true);
                //console.log(this.idAyudante);
                //console.log(this.ArrayFirmas);
              } else {
                this.$vs.notify({
                  time: 5000,
                  color: "danger",
                  title: "Alerta",
                  text: "El Operador / Ayudante es requerido.",
                });

                fgValidate = false;
                reject("correct all values");
              }
            }

            if (this.fgCliente.fgVisible || this.fgNombreCliente.fgVisible) {
              if (this.idCliente || this.Nombre) {
                for (let i in this.ArrayFirmas) {
                  if (this.ArrayFirmas[i].TipoResponsableID == 7) {
                    //idCliente
                    if (this.Nombre && this.fgNombreCliente.fgVisible) {
                      this.ArrayFirmas[i].lsResponsables.push({
                        id: this.Nombre,
                        label: this.Nombre + " (Cliente)",
                      });
                    } else {
                      if (this.idCliente && this.fgCliente.fgVisible) {
                        this.ArrayFirmas[i].lsResponsables.push({
                          id: this.idCliente.label,
                          label: this.idCliente.label + " (Cliente)",
                        });
                      }
                    }
                  }
                }
                resolve(true);
              } else {
                this.$vs.notify({
                  time: 5000,
                  color: "danger",
                  title: "Alerta",
                  text: "El Cliente es requerido.",
                });

                fgValidate = false;
                reject("correct all values");
              }
            }
            if (fgValidate) {
              resolve(true);
            }
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then((result) => {
          if (this.fgConsultar) {
            setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
            if (this.Activo == 0) {
              //console.log(this.selected)
            }

            if (!this.fgConsultar) {
              if (this.HojaIID == 0) {
                if (this.CuestionarioEmpresa.Secciones.length > 0) {
                  for (let s in this.CuestionarioEmpresa.Secciones) {
                    if (
                      this.CuestionarioEmpresa.Secciones[s].Origen == "SALIDA"
                    ) {
                      for (let p in this.CuestionarioEmpresa.Secciones[s]
                        .Preguntas) {
                        this.selected.push(
                          this.CuestionarioEmpresa.Secciones[s].Preguntas[p]
                        );
                      }
                    }
                  }
                }
              } else if (this.HojaIID > 0 && this.fgLlegada) {
                if (this.CuestionarioEmpresa.Secciones.length > 0) {
                  for (let s in this.CuestionarioEmpresa.Secciones) {
                    if (
                      this.CuestionarioEmpresa.Secciones[s].Origen == "LLEGADA"
                    ) {
                      for (let p in this.CuestionarioEmpresa.Secciones[s]
                        .Preguntas) {
                        this.selected.push(
                          this.CuestionarioEmpresa.Secciones[s].Preguntas[p]
                        );
                      }
                    }
                  }
                }
              }
            }
            resolve(result);
            reject("Correcto");
          } else {
            if (result) {
              let vm = this;
              let validateOdometro = {};
              let kSalida = 0;
              let KFinal = 0;
              let fgError = false;

              if (
                this.fgMedidorCombustibleSalida.fgVisible &&
                this.idCombustible.id == 0
              ) {
                fgError = true;
              }

              if (
                this.fgMedidorCombustibleLlegada.fgVisible &&
                this.idCombustibleLlegada.id == 0 &&
                this.HojaIID > 0 &&
                this.fgLlegada
              ) {
                fgError = true;
              }

              if (fgError) {
                if (this.idCombustible.id == 0) {
                  this.$vs.notify({
                    time: 5000,
                    color: "danger",
                    title: "Alerta",
                    text: "El combustible de salida es requerido.",
                  });
                }

                if (this.idCombustibleLlegada.id == 0 && this.HojaIID > 0) {
                  this.$vs.notify({
                    time: 5000,
                    color: "danger",
                    title: "Alerta",
                    text: "El combustible de Llegada es requerido.",
                  });
                }

                setTimeout(() => {
                  this.$vs.loading.close();
                }, 500);
                reject("correct all values");
              }

              if (
                this.KilometrajeFinal != null &&
                this.KilometrajeFinal != "" &&
                !fgError
              ) {
                kSalida = parseFloat(
                  this.Kilometraje != null
                    ? this.Kilometraje.split(",").join("")
                    : this.Kilometraje
                );

                KFinal = parseFloat(
                  this.KilometrajeFinal != null
                    ? this.KilometrajeFinal.split(",").join("")
                    : this.KilometrajeFinal
                );
              } else {
                kSalida = parseFloat(this.KilometrajeEdicion);

                KFinal = parseFloat(
                  this.Kilometraje != null
                    ? this.Kilometraje.split(",").join("")
                    : this.Kilometraje
                );
              }

              if (this.HojaIID > 0 && this.fgLlegada) {
                if (KFinal < kSalida) {
                  this.$vs.notify({
                    time: 5000,
                    color: "danger",
                    title: "Alerta",
                    text:
                      "El kilometraje de llegada no puede ser menor al de salida.",
                  });

                  setTimeout(() => {
                    this.$vs.loading.close();
                  }, 500);
                  reject("correct all values");
                } else {
                  if (KFinal > kSalida) {
                    this.$vs.loading();
                    let UOdometro = {
                      VehiculoID: this.idVehiculo.id,
                      Odometro: this.fgLlegada ? KFinal : kSalida,
                      LongitudID: 1,
                    };
                    $.ajax({
                      url: this.WS + "/Vehiculo/ValidateOdometro",
                      type: "POST",
                      dataType: "Json",
                      async: false,
                      data: UOdometro,
                      success: (res) => {
                        validateOdometro = res;
                        //console.log(res);
                      },
                    });

                    if (validateOdometro.Exitoso == 0) {
                      this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: validateOdometro.mensaje,
                      });

                      setTimeout(() => {
                        this.$vs.loading.close();
                      }, 500);
                      reject("correct all values");
                    } else {
                      setTimeout(() => {
                        this.$vs.loading.close();
                      }, 500);
                      resolve(true);
                      if (!this.fgConsultar) {
                        if (this.HojaIID == 0) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              if (
                                this.CuestionarioEmpresa.Secciones[s].Origen ==
                                "SALIDA"
                              ) {
                                for (let p in this.CuestionarioEmpresa
                                  .Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                              }
                            }
                          }
                        } else if (this.HojaIID > 0 && this.fgLlegada) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              if (
                                this.CuestionarioEmpresa.Secciones[s].Origen ==
                                "LLEGADA"
                              ) {
                                for (let p in this.CuestionarioEmpresa
                                  .Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    resolve(true);
                  }
                }
              } else {
                this.$vs.loading();
                let USOdometro = {
                  VehiculoID: vm.idVehiculo.id,
                  Odometro: this.Kilometraje.split(",").join(""),
                  LongitudID: 1,
                };

                $.ajax({
                  url: this.WS + "/Vehiculo/ValidateOdometro",
                  type: "POST",
                  dataType: "Json",
                  async: false,
                  data: USOdometro,
                  success: (res) => {
                    //console.log(res);
                    validateOdometro = res;
                  },
                });

                if (validateOdometro.Exitoso == 0) {
                  this.$vs.notify({
                    time: 5000,
                    color: "danger",
                    title: "Alerta",
                    text: validateOdometro.mensaje,
                  });

                  setTimeout(() => {
                    this.$vs.loading.close();
                  }, 500);
                  reject("correct all values");
                } else {
                  setTimeout(() => {
                    this.$vs.loading.close();
                  }, 500);
                  resolve(true);
                  if (!this.fgConsultar) {
                    if (this.HojaIID == 0) {
                      if (this.CuestionarioEmpresa.Secciones.length > 0) {
                        for (let s in this.CuestionarioEmpresa.Secciones) {
                          if (
                            this.CuestionarioEmpresa.Secciones[s].Origen ==
                            "SALIDA"
                          ) {
                            for (let p in this.CuestionarioEmpresa.Secciones[s]
                              .Preguntas) {
                              this.selected.push(
                                this.CuestionarioEmpresa.Secciones[s].Preguntas[
                                  p
                                ]
                              );
                            }
                          }
                        }
                      }
                    } else if (this.HojaIID > 0 && this.fgLlegada) {
                      if (this.CuestionarioEmpresa.Secciones.length > 0) {
                        for (let s in this.CuestionarioEmpresa.Secciones) {
                          if (
                            this.CuestionarioEmpresa.Secciones[s].Origen ==
                            "LLEGADA"
                          ) {
                            for (let p in this.CuestionarioEmpresa.Secciones[s]
                              .Preguntas) {
                              this.selected.push(
                                this.CuestionarioEmpresa.Secciones[s].Preguntas[
                                  p
                                ]
                              );
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              setTimeout(() => {
                this.$vs.loading.close();
              }, 500);
              reject("correct all values");
            }
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        resolve(true);
        reject("correct all values");
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        resolve(true);
        reject("correct all values");
      });
    },
    validateStep5() {
      return new Promise((resolve, reject) => {
        //console.log(this.ArrayFirmas);
        if (this.ArrayFirmas.length > 0) {
          let validateFirma = true;
          //let count = 0;
          for (var index in this.ArrayFirmas) {
            if (this.HojaIID > 0) {
              if (this.ArrayFirmas[index].lsFirmas.length > 0) {
                if (!this.fgLlegada) {
                  let indexSelected = 0;
                  $.each(this.$refs.signaturePad_salida, (c, ref) =>{
                    //console.log(ref);
                    if(ref.$attrs.id == "signature"+index){
                      indexSelected = c;
                    }
                  });
                  const { isEmpty, data } = this.$refs.signaturePad_salida[
                    indexSelected
                  ].saveSignature();

                  if (!isEmpty) {
                    this.ArrayFirmas[index].lsFirmas[0].Firma = data;
                  }
                  // console.log(this.ArrayFirmas[index].lsFirmas);
                  // console.log(this.ArrayFirmas[index].lsFirmas[0].Nombre);
                  if (!this.ArrayFirmas[index].lsFirmas[0].Nombre) {
                    validateFirma = false;
                  } else {
                    this.ArrayFirmas[index].lsFirmas[0].Nombre =
                      this.ArrayFirmas[index].lsFirmas[0].Nombre.id != undefined
                        ? this.ArrayFirmas[index].lsFirmas[0].Nombre.id
                        : this.ArrayFirmas[index].lsFirmas[0].Nombre;
                    //console.log(this.ArrayFirmas[index].lsFirmas[0].Nombre)
                  }
                } else {
                  let indexSelected = 0;
                  $.each(this.$refs.signaturePad, (c, ref) =>{
                    //console.log(ref);
                    if(ref.$attrs.id == "signature"+index){
                      indexSelected = c;
                    }
                  });
                  const { isEmpty, data } = this.$refs.signaturePad[
                    indexSelected
                  ].saveSignature();

                  let indexLL = (this.ArrayFirmas[index].Origen == null) ? 1 : 0;      
                  if (!isEmpty) {
                    this.ArrayFirmas[index].lsFirmas[indexLL].Firma = data;
                  }

                  if (!this.ArrayFirmas[index].lsFirmas[indexLL].Nombre) {
                    validateFirma = false;
                  } else {
                    //if(this.Activo == 0){
                    // console.log(this.ArrayFirmas[index].lsFirmas[indexLL]);
                    // console.log(this.ArrayFirmas[index].lsFirmas[indexLL].Nombre.id);
                    this.ArrayFirmas[index].lsFirmas[indexLL].Nombre =
                      this.ArrayFirmas[index].lsFirmas[indexLL].Nombre.id != undefined
                        ? this.ArrayFirmas[index].lsFirmas[indexLL].Nombre.id
                        : this.ArrayFirmas[index].lsFirmas[indexLL].Nombre;
                    // }else{
                    //   if(index == 0){
                    //     this.ArrayFirmas[
                    //       index
                    //     ].lsFirmas[1].Nombre = this.ArrayFirmas[
                    //       index
                    //     ].lsFirmas[1].Nombre;
                    //   }else{
                    //     this.ArrayFirmas[
                    //       index
                    //     ].lsFirmas[1].Nombre = this.ArrayFirmas[
                    //       index
                    //     ].lsFirmas[1].Nombre.id;
                    //   }
                    // }
                  }
                }

                if (validateFirma == false) {
                  this.$vs.notify({
                    time: 5000,
                    fixed: true,
                    color: "danger",
                    title: this.ArrayFirmas[index].Nombre,
                    text: "Los campos nombre y firma son requeridos.",
                  });
                }
              } else {
                const { isEmpty, data } = this.$refs.signaturePad[
                  index
                ].saveSignature();

                if (!isEmpty) {
                  this.ArrayFirmas[index].lsFirmas[1].Firma = data;
                } else {
                  validateFirma = false;
                  this.ArrayFirmas[index].lsFirmas[1].Firma = null;
                }

                if (!this.ArrayFirmas[index].lsFirmas[1].Nombre) {
                  validateFirma = false;
                }

                if (validateFirma == false) {
                  this.$vs.notify({
                    time: 5000,
                    fixed: true,
                    color: "danger",
                    title: this.ArrayFirmas[index].Nombre,
                    text: "Los campos nombre y firma son requeridos.",
                  });
                }
              }
            } else {
              //$.each(this.$refs.signaturePad_salida, (c) => {
              const { isEmpty, data } = this.$refs.signaturePad_salida[
                index
              ].saveSignature();
              if (!isEmpty) {
                this.ArrayFirmas[index].lsFirmas[0].Firma = data;
              } else {
                validateFirma = false;
                this.ArrayFirmas[index].lsFirmas[0].Firma = null;
              }

              if (!this.ArrayFirmas[index].lsFirmas[0].Nombre) {
                validateFirma = false;
              } else {
                this.ArrayFirmas[index].lsFirmas[0].Nombre =
                  this.ArrayFirmas[index].lsFirmas[0].Nombre.id != undefined
                    ? this.ArrayFirmas[index].lsFirmas[0].Nombre.id
                    : this.ArrayFirmas[index].lsFirmas[0].Nombre;
              }

              if (this.fgConsultar) {
                validateFirma = true;
              }

              if (validateFirma == false) {
                this.$vs.notify({
                  time: 5000,
                  fixed: true,
                  color: "danger",
                  title: this.ArrayFirmas[index].Nombre,
                  text: "Los campos nombre y firma son requeridos.",
                });
              }
              //});
            }
          }

          //console.log(validateFirma);
          if (validateFirma) {
            resolve(true);
          }
          reject("correct all values");
        } else {
          resolve(true);
          reject("correct all values");
        }
      });
    },
    forceRerenderForm() {
      this.renderForm = false;
      this.$nextTick(() => {
        this.renderForm = true;
      });
    },
    //SAVE

    saveInformacion() {
      this.$vs.loading();

      const vm = this;
      const datosSend = {};

      //console.log(vm.idOperador);
      datosSend.HojaInspeccionID = vm.HojaIID;
      datosSend.OperadorID = vm.fgOperador.fgVisible
        ? vm.idOperador
          ? vm.idOperador.id
          : null
        : null;
      if (vm.fgAyudante.fgVisible) {
        datosSend.ayudantes = [];
        for (let y in vm.idAyudante) {
          datosSend.ayudantes.push({
            AyudanteID: vm.idAyudante[y].id,
            HojaInspeccionID: vm.HojaIID > 0 ? vm.HojaIID : 0,
          });
        }
      } else {
        datosSend.Ayudantes = [];
      }
      datosSend.FechaRegistro =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      datosSend.ClienteID = vm.fgCliente.fgVisible ? vm.idCliente.id : null;
      datosSend.Contrato = vm.fgContrato.fgVisible ? vm.Contrato : null;
      datosSend.Factura = vm.fgFactura.fgVisible ? vm.Factura : null;
      datosSend.Estacion = vm.fgEstacion.fgVisible ? vm.idEstacion.label : null;
      datosSend.VehiculoID = vm.fgVehiculo.fgVisible ? vm.idVehiculo.id : null;
      datosSend.TipoVehiculoID = vm.fgTipoVehiculo.fgVisible
        ? vm.idTipoVehiculo.id
        : null;
      datosSend.InspectorID = vm.fgInspector.fgVisible
        ? vm.idEmpleado.id
        : null;
      datosSend.TipoCombustibleID = vm.fgTipoCombustible.fgVisible
        ? vm.idTipoCombustible != null
          ? vm.idTipoCombustible.id
          : "Empty"
        : null;
      datosSend.Kilometraje = vm.fgKilometrajeSalida.fgVisible
        ? vm.Kilometraje.split(",").join("")
        : null;
      //Llegadas
      datosSend.KilometrajeLlegada =
        vm.fgKilometrajeLlegada.fgVisible && vm.HojaIID > 0 && vm.fgLlegada
          ? vm.KilometrajeFinal.split(",").join("")
          : null;
      datosSend.CombustibleLlegada =
        (vm.fgCombustibleFinal.fgVisible ||
          vm.fgMedidorCombustibleLlegada.fgVisible) &&
        vm.HojaIID > 0 &&
        vm.fgLlegada
          ? vm.idCombustibleLlegada.id
          : null;
      datosSend.FechaLlegada =
        vm.fgFechaLlegada.fgVisible && vm.HojaIID > 0 && vm.fgLlegada
          ? new Date(vm.fLlegada).getFullYear() +
            "-" +
            (new Date(vm.fLlegada).getMonth() + 1) +
            "-" +
            new Date(vm.fLlegada).getDate()
          : null;
      datosSend.HoursLlegada =
        vm.fgHoraLlegada.fgVisible && vm.HojaIID > 0 && vm.fgLlegada
          ? vm.timeLlegada
          : null;
      datosSend.LitrosCargados =
        vm.fgLitrosCargados.fgVisible && vm.HojaIID > 0 && vm.fgLlegada
          ? vm.litrosCargados.split(",").join("")
          : null;
      //

      datosSend.FechaSalida = vm.fgFechaSalida.fgVisible
        ? new Date(vm.fSalida).getFullYear() +
          "-" +
          (new Date(vm.fSalida).getMonth() + 1) +
          "-" +
          new Date(vm.fSalida).getDate()
        : null;
      datosSend.Hours = vm.fgHoraSalida.fgVisible ? vm.time : null;
      //vm.HojaIID > 0
      //? vm.time
      //: new Date(vm.time).getHours() + ":" + new Date(vm.time).getMinutes(); /////
      datosSend.DetalleVehiculo = vm.fgDetalleVehiculo.fgVisible
        ? vm.Comentarios
        : null;
      datosSend.Activo = vm.HojaIID > 0 && vm.fgLlegada ? 1 : 0;
      datosSend.NombreCliente = vm.fgNombreCliente.fgVisible ? vm.Nombre : null;
      datosSend.TipoInspeccion = vm.fgTipoDocumento.fgVisible
        ? vm.idTipoDocumento.id
        : null;
      datosSend.TipoChasisID = vm.fgTipoChasis.fgVisible
        ? vm.idTipoChasis.id
        : null;
      datosSend.Averias = vm.pointsMarker;
      //console.log(vm.idCombustible.id);
      datosSend.Combustible =
        vm.fgCombustibleInicial.fgVisible ||
        vm.fgMedidorCombustibleSalida.fgVisible
          ? vm.idCombustible.id
          : null;
      datosSend.EmpresaID = authConfig.EmpresaId;
      datosSend.Cuestionario = [];
      if (vm.selected.length > 0) {
        for (let i = 0; i < vm.selected.length; i++) {
          let objCuestionario = {};
          //objCuestionario.HojaInspeccionID = HiID;
          objCuestionario.PreguntaID = vm.selected[i].PreguntaID;
          objCuestionario.RespuestaID =
            vm.selected[i].Respuestas[0].RespuestaID;
          datosSend.Cuestionario.push(objCuestionario);
        }
      }

      datosSend.Firmas = vm.ArrayFirmas;
      datosSend.Otros = vm.Otros;
      datosSend.fgLlegada = vm.fgLlegada;

      setTimeout(() => {
        let validateOdometro = {};

        let UOdometro = {
          VehiculoID: datosSend.VehiculoID,
          Odometro:
            vm.HojaIID > 0 && vm.fgLlegada
              ? datosSend.KilometrajeLlegada
              : datosSend.Kilometraje,
          LongitudID: 1,
        };
        $.ajax({
          url: this.Api + "/api/Vehiculo/UpdateOdometro",
          type: "POST",
          dataType: "Json",
          async: false,
          data: UOdometro,
          success: (res) => {
            validateOdometro = res;
          },
        });

        if (validateOdometro.Exitoso == 0) {
          this.$vs.notify({
            time: 5000,
            color: "danger",
            title: "Alerta",
            text: validateOdometro.mensaje,
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
          return;
        }

        $.ajax({
          url: this.WS + "/Checklist/saveHojaInspeccion",
          type: "POST",
          dataType: "Json",
          async: false,
          data: datosSend,
          success: (res) => {
            if (res.Estatus == -1) {
              this.$vs.notify({
                time: 5000,
                color: "danger",
                title: "Alerta",
                text:
                  "Ocurrió un error inesperado, favor de intentarlo de nuevo.",
              });

              setTimeout(() => {
                this.$vs.loading.close();
              }, 500);

              return;
            } else if (res.Estatus == 0) {
              this.$vs.notify({
                time: 5000,
                color: "danger",
                title: "Alerta",
                text: res.Mensaje,
              });

              setTimeout(() => {
                this.$vs.loading.close();
              }, 500);

              return;
            }

            //vm.saveCuestionario(res.body.hojasInspeccion[0].HojaInspeccionID);
            //vm.getInfoInspeccionxID(res.Data);
            if (vm.HojaIID > 0) {
              this.$vs.notify({
                time: 5000,
                color: "success",
                fixed: true,
                title: "Operación exitosa",
                text:
                  "La hoja de Inspección No: " +
                  res.Data +
                  " se ha actualizado correctamente",
              });
            } else {
              this.$vs.notify({
                time: 5000,
                fixed: true,
                color: "success",
                title: "Operación exitosa",
                text: "Hoja de Inspección creada con éxito No: " + res.Data,
              });
            }

            setTimeout(() => {
              this.$vs.loading.close();
              this.popupActive = false;
              this.forceRerenderForm();
              vm.searchInspeccion();
            }, 500);
          },
          error: () => {
            //console.log(errorThrown);
            this.$vs.notify({
              time: 5000,
              color: "warning",
              title: "Ocurrió un error inesperado",
              text: "No se ha podido conectar al servidor. Intente más tarde",
            });

            setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
          },
        });
      }, 1000);
    },

    //Catálogos

    getClientes() {
      $.ajax({
        url: this.Api + "/api/Cliente/GetByEmpresaID/" + authConfig.EmpresaId, //authConfig.EmpresaId;,
        type: "GET",
        dataType: "Json",
        async: false,
        success: (res) => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res) {
            this.options1.push({
              id: res[i].ClienteID,
              label: res[i].Nombre,
            });
          }
        },
      });
    },
    getSucursales() {
      $.ajax({
        url: this.Api + "/api/Reportes/ConsultarSucursales",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //authConfig.EmpresaId;,
        async: false,
        success: (res) => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res.obj) {
            this.options5.push({
              id: res.obj[i].sucursal_id,
              label: res.obj[i].sucursal_nombre,
            });
          }
        },
      });
    },
    getVehiculos() {
      $.ajax({
        url:
          this.Api + "/api/Vehiculo/GetByEmpresaIDNS/" + authConfig.EmpresaId,
        type: "GET",
        dataType: "Json",
        async: false,
        success: (res) => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.LsAllVehiculos = [];
          for (var i in res) {
            this.LsAllVehiculos.push(res[i]);
          }
        },
      });
    },
    getVehiculosByTipo(id) {
      this.options4 = [];
      this.LsVehiculos = [];      
      for (var i in this.LsAllVehiculos) {
        if (this.LsAllVehiculos[i].TipoVehiculo.TipoVehiculoID == id) {
          this.LsVehiculos.push(this.LsAllVehiculos[i]);

          this.options4.push({
            id: this.LsAllVehiculos[i].VehiculoID,
            label: this.LsAllVehiculos[i].Nombre,
          });
        }
      }
      //console.log(this.LsVehiculos);
      this.idVehiculo = this.options4[0];
      //console.log(this.idVehiculo);
    },
    getEmpleados() {
      $.ajax({
        url:
          this.Api +
          "/api/EmpleadoUsuario/GetAllEmpleadosByEmpresaID/" +
          authConfig.EmpresaId, //authConfig.EmpresaId;,
        type: "GET",
        dataType: "Json",
        async: false,
        success: (res) => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res) {
            this.options6.push({
              id: res[i].EmpleadoID,
              label: res[i].Nombre,
            });
          }          
        },
      });
    },
    getLlantasVehiculo(x) {
      $.ajax({
        url: this.Api + "/api/Llantas/GetByVehiculoIDSNV/" + x,
        type: "GET",
        dataType: "Json",
        success: (res) => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.LsLlantas = res;
        },
      });
    },
    getTiposVehiculos() {
      $.ajax({
        url: this.WS + "/Checklist/getTiposVehiculosByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //authConfig.EmpresaId;,
        success: (res) => {
          if (res.Estatus != 1) {
            throw new Error(res.Mensaje);
          }
          this.TiposVehiculos = res.Data;
          //console.log(this.TiposVehiculos);
        },error(){
           this.$vs.notify({
              time: 5000,
              color: "warning",
              title: "Ocurrió un error inesperado",
              text: "No se ha podido conectar al servidor. Intente más tarde",
            });
        }
      });
    },
    getCuestionario(tipoVehiculo) {
      $.ajax({
        url: this.WS + "/Checklist/getCuestionarioByEmpresa",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { EmpresaID: authConfig.EmpresaId, ID: 1,TipoVehiculoID:tipoVehiculo.id,
                HojaInspeccionModoEdicion:this.HojaInspeccionModoEdicion }, //authConfig.EmpresaId;,
        success: (res) => {
          //console.log(res);
          if (res.Estatus != 1) {
            throw new Error(res.Mensaje);
          }
          this.CuestionarioEmpresa = res.Data;
        }, error(){
           this.$vs.notify({
              time: 5000,
              color: "warning",
              title: "Ocurrió un error inesperado",
              text: "No se ha podido conectar al servidor. Intente más tarde",
            });
        },
      });
    },
    getTipoDocumentos() {
      $.ajax({
        url: this.WS + "/Checklist/getTipoDocumentos",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { EmpresaID: authConfig.EmpresaId }, //authConfig.EmpresaId;,
        success: (res) => {
          if (res.Estatus != 1) {
            throw new Error(res.Mensaje);
          }
          this.options2 = res.Data;
        },
        error(){
            this.$vs.notify({
              time: 5000,
              color: "warning",
              title: "Ocurrió un error inesperado",
              text: "No se ha podido conectar al servidor. Intente más tarde",
            });
        }
      });
    },
    getTiposCombustible() {
      $.ajax({
        url: this.WS + "/Checklist/getTiposCombustible",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { EmpresaID: authConfig.EmpresaId }, //authConfig.EmpresaId;,
        success: (res) => {
          if (res.Estatus != 1) {
            throw new Error(res.Mensaje);
          }
          this.options8 = res.Data;
        },
        error(){
           this.$vs.notify({
              time: 5000,
              color: "warning",
              title: "Ocurrió un error inesperado",
              text: "No se ha podido conectar al servidor. Intente más tarde",
            });
        }
      });
    },
    getCamposHojaInspeccion() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/CamposHojaInspeccionByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 1, type: (vm.fgLlegada ? "LLEGADA" : "SALIDA")},
        success: (res) => {
          //return false;
          let dict = {
            custom: {},
          };
          vm.fgCliente.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgCliente.Campo) {
                return item;               
              }
            })).length > 0 ? (res.Data.filter((item) => {
              if (item.Campo == vm.fgCliente.Campo) {
                return item;               
              }
            })[0].Visible == 1
              ? true
              : false) : false;

          let fgCheckW = false;
          for (let cp in res.Data) {
            if (vm.fgChecklistW.Campo == res.Data[cp].Campo) {
              fgCheckW = true;
            }
          }
          vm.fgChecklistW.fgVisible = fgCheckW;
          vm.fgNombreCliente.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgNombreCliente.Campo) {
                // if (item.Visible == 1) {
                //   dict.custom["v_Nombre"] = {
                //     required: "El campo nombre es requerido.",
                //   };
                // } else {
                //   vm.NombreCliente = "Empty";
                // }
                return item;
              }
            })).length > 0
              ? res.Data.filter((item) => {
                  if (item.Campo == vm.fgNombreCliente.Campo) {
                    if (item.Visible == 1) {
                      dict.custom["v_Nombre"] = {
                        required: "El campo nombre es requerido.",
                      };
                    } else {
                      vm.NombreCliente = "Empty";
                    }
                    return item;
                  }
                })[0].Visible == 1
                ? true
                : false
              : false;
          vm.fgTipoDocumento.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoDocumento.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoDocumento"] = {
                    required: "El campo tipo de documento es requerido.",
                  };
                } else {
                  vm.idTipoDocumento = { id: 0, label: "" };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoDocumento.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoDocumento"] = {
                    required: "El campo tipo de documento es requerido.",
                  };
                } else {
                  vm.idTipoDocumento = { id: 0, label: "" };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgTipoVehiculo.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoVehiculo.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoVehiculo"] = {
                    required: "El campo tipo de vehículo es requerido.",
                  };
                } else {
                  vm.idTipoVehiculo = { id: 0, label: "" };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoVehiculo.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoVehiculo"] = {
                    required: "El campo tipo de vehículo es requerido.",
                  };
                } else {
                  vm.idTipoVehiculo = { id: 0, label: "" };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgVehiculo.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgVehiculo.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idVehiculo"] = {
                    required: "El campo vehículo es requerido.",
                  };
                } else {
                  vm.idVehiculo = { id: 0, label: "" };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgVehiculo.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idVehiculo"] = {
                    required: "El campo vehículo es requerido.",
                  };
                } else {
                  vm.idVehiculo = { id: 0, label: "" };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgTipoChasis.fgVisible = false;
          vm.fgEstacion.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgEstacion.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idEstacion"] = {
                    required: "El campo estación dueña es requerido.",
                  };
                } else {
                  vm.idEstacion = { id: 0, label: "" };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgEstacion.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idEstacion"] = {
                    required: "El campo estación dueña es requerido.",
                  };
                } else {
                  vm.idEstacion = { id: 0, label: "" };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgInspector.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgInspector.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idEmpleado"] = {
                    required: "El campo inspector de operaciones es requerido.",
                  };
                } else {
                  vm.idEmpleado = { id: 0, label: "" };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgInspector.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idEmpleado"] = {
                    required: "El campo inspector de operaciones es requerido.",
                  };
                } else {
                  vm.idEmpleado = { id: 0, label: "" };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgContrato.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgContrato.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Contrato"] = {
                    required: "El campo contrato es requerido.",
                  };
                } else {
                  vm.Contrato = "Empty";
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgContrato.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Contrato"] = {
                    required: "El campo contrato es requerido.",
                  };
                } else {
                  vm.Contrato = "Empty";
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgFactura.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgFactura.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Factura"] = {
                    required: "El campo factura es requerido.",
                  };
                } else {
                  vm.Factura = "Empty";
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgFactura.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Factura"] = {
                    required: "El campo factura es requerido.",
                  };
                } else {
                  vm.Factura = "Empty";
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgTipoCombustible.fgVisible =
            res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoCombustible.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoCombustible"] = {
                    required: "El campo tipo de combustible es requerido.",
                  };
                } else {
                  //vm.idTipoVehiculo = { id:0, label:''}
                }
                return item;
              }
            }).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgTipoCombustible.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idTipoCombustible"] = {
                    required: "El campo tipo de combustible es requerido.",
                  };
                } else {
                  //vm.idTipoVehiculo = { id:0, label:''}
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgCombustibleInicial.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgCombustibleInicial.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idCombustible"] = {
                    required: "El campo combustible es requerido.",
                  };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgCombustibleInicial.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idCombustible"] = {
                    required: "El campo combustible es requerido.",
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgCombustibleFinal.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgCombustibleFinal.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idCombustibleLlegada"] = {
                    required: "El campo combustible de Llegada es requerido.",
                  };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgCombustibleFinal.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idCombustibleLlegada"] = {
                    required: "El campo combustible de Llegada es requerido.",
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgMedidorCombustibleSalida.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleSalida.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleSalida.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgMedidorCombustibleSalida.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleSalida.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleSalida.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;          

          vm.fgMedidorCombustibleLlegada.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleLlegada.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgMedidorCombustibleLlegada.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgHoraSalida.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgHoraSalida.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgHoraSalida.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgKilometrajeSalida.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgKilometrajeSalida.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Kilometraje"] = {
                    required: "El campo kilometraje es requerido.",
                  };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgKilometrajeSalida.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Kilometraje"] = {
                    required: "El campo kilometraje es requerido.",
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgFechaLlegada.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgFechaLlegada.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgFechaLlegada.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgHoraLlegada.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgHoraLlegada.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgHoraLlegada.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgKilometrajeLlegada.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgKilometrajeLlegada.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_KilometrajeFinal"] = {
                    required: "El campo kilometraje de llegada es requerido.",
                  };
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgKilometrajeLlegada.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_KilometrajeFinal"] = {
                    required: "El campo kilometraje de llegada es requerido.",
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgLitrosCargados.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgLitrosCargados.Campo) {
                // if (item.Visible == 1) {
                //   dict.custom["v_litrosCargados"] = {
                //     required: "El campo litros cargados es requerido.",
                //   };
                // }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgLitrosCargados.Campo) {
                // if (item.Visible == 1) {
                //   dict.custom["v_litrosCargados"] = {
                //     required: "El campo litros cargados es requerido.",
                //   };
                // }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgDetalleVehiculo.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgDetalleVehiculo.Campo) {
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgDetalleVehiculo.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgOperador.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgOperador.Campo) {
                return item;
              }
            })).length > 0
              ? res.Data.filter((item) => {
                  if (item.Campo == vm.fgOperador.Campo) {
                    return item;
                  }
                })[0].Visible == 1
                ? true
                : false
              : false;

          this.fgAyudante.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgAyudante.Campo) {
                return item;
              }
            })).length > 0
              ? (res.Data.filter((item) => {
                  if (item.Campo == vm.fgAyudante.Campo) {
                    return item;
                  }
                })[0].Visible === 1
                ? true
                : false)
              : false;


          Validator.localize("en", dict);
        },
      });
    },
    getCamposFirmas() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/CamposFirmasByEmpresa",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { EmpresaID: authConfig.EmpresaId, ID: 1, type: (this.fgLlegada ? "LLEGADA" : "SALIDA") },
        success: (res) => {
          if (res.Estatus === 1) {
            this.ArrayFirmas = res.Data;
            //console.log(res.Data);
          }
        },
      });
    },
    getFolioHojaInspeccion() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/getFolioHojaInspeccion",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 1, type: "1" },
        success: (res) => {
          if (res.Estatus === 1) {
            //this.ArrayFirmas = res.Data;
          }else{
            this.ActiveHI = false;
            this.$vs.notify({
                time: 6000,
                color: "danger",
                title: "Alerta",
                text:
                  "No es posible registrar una hoja de inspección debido a que no existe folio para la empresa "+ res.Data,
              });
          }
        },
      });
    },
    getOperadoresVehiculo(id) {
      let vm = this;
      this.$vs.loading();
      //this.idOperador = null;
      $.ajax({
        url: vm.WS + "/Checklist/getOperadoresByVehiculo",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { ID: id },
        success: (res) => {
          if (res.Data.length > 0) {
            this.idOperador = res.Data[0];
            //console.log(this.fgAyudante.Visible);
            if(this.fgAyudante.fgVisible == true && !this.fgConsultar){
              //console.log(this.options6);
              //if(this.HojaIID > 0)
              this.idAyudante = this.options6[0]
            }            
            this.optionsO = res.Data;
          } else {
            this.idOperador = null;
            this.optionsO = [];
            if (this.HojaIID == 0) {
              this.$vs.notify({
                time: 6000,
                color: "danger",
                title: "Alerta",
                text:
                  "No se encontraron operadores para el vehículo seleccionado.",
              });
            }
          }
        },
      });

      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    getAveriasNoAtendidasByVehiculo(id) {
      let vm = this;
      this.$vs.loading();
      //this.pointsMarker = [];
      
      //this.idOperador = null;
      $.ajax({
        url: vm.WS + "/Checklist/getAveriasNoAtendidasByVehiculo",
        type: "POST",
        dataType: "Json",
        async: false,
        data: { ID: id, tipoAveriaID: 0 },
        success: (res) => {
         

          if(this.HojaIID == 0 || (this.HojaIID > 0 && this.fgConsultar == true) || (this.HojaIID > 0 && this.fgLlegada == true)){
            this.pointsMarker = [];
            this.namePoint = null;
            this.pointOne = null;
            this.pointTwo = null;
            this.pointThre = null;
            this.pointFor = null;
            this.pointFive = null;
            this.pointSix = null;
            this.pointSeven = null;
            this.pointEigth = null;
            this.pointNine = null;
            this.pointTen = null;
            this.pointEleven = null;
            this.pointTwelve = null;
            this.pointThirteen = null;
            this.pointFourTeen = null;
            this.pointFifTeen = null;
            this.pointSixTeen = null;
            this.pointSevenTeen = null;
            this.pointEigthTeen = null;
            this.pointNineTeen = null;
            this.pointTwenty = null;
            this.tipoAveriaID = null;        
          }
          
          if (res.Data.length > 0 && (this.HojaIID == 0 || (this.HojaIID > 0 && this.fgLlegada == true))) {    

            const infoAverias =
            this.arregloImgsCarro.length > 0 ? res.Data : [];
            if (infoAverias.length > 0) {
              for (let i = 0; i < infoAverias.length; i++) {
                const tipoAveriaName = vm.tipoAverias.filter((item) => {
                  if (item.id === infoAverias[i].TipoAveria) {
                    return item;
                  }
                });
                this.pointsMarker.push({
                  AveriaID: 1,
                  Numero: infoAverias[i].Numero,
                  Detalle: infoAverias[i].Detalle,
                  EjeX: infoAverias[i].EjeX,
                  EjeY: infoAverias[i].EjeY,
                  ImagenID: infoAverias[i].ImagenID,
                  TipoAveria: tipoAveriaName[0].id,
                  Nombre: this.arregloImgsCarro.filter((item) => {
                    if (item.id === infoAverias[i].ImagenID) {
                      return item;
                    }
                  })[0].titulo,
                  AveriaName: tipoAveriaName[0].label,
                  FechaRegistro: infoAverias[i].FechaRegistro,
                  Origen: infoAverias[i].Origen,
                });
              }
              this.paintPoints();
            } else {
              this.pointsMarker = [];
            }
          } 
        },
      });
      $("input[class='input-search vs-table--search-input']").val("R");
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
  },
};
</script>